document.addEventListener('DOMContentLoaded', () => {
  let timeout; // Timeout reference
  let isFetching = false; // Prevent overlapping requests
  let currentConversationId = null; // Track the current conversation ID
  let followUpButtonTimeout = null; // Timeout for follow-up button appearance (no longer used, but preserved)
  let newSearchClicked = false; // Track if New Search button was clicked
  let inChatMode = false; // Track if we're in chat mode
  let isStreaming = false; // Track if we're currently streaming a response
  let scrollCheckInterval = null; // Interval for checking scroll position
  let proModeEnabled = true; // Default to PRO mode enabled
  let remainingProSearches = 3; // Default to 3 free searches
  let statusIntervalId = null; // <<< Added: Store interval ID for status messages

  // --- Safety Override for EventSource ---
  // This prevents any accidental EventSource creation with unsafe URLs or methods
  const originalEventSource = window.EventSource;
  window.EventSource = function(url, options) {
    // Check if this is an unsafe EventSource creation
    if (url === '/ask' || url.startsWith('/ask?')) {
      if (!options || options.method !== 'POST') {
        console.warn("⚠️ Prevented unsafe EventSource creation with GET to /ask");
        console.trace("Stack trace for unsafe EventSource attempt:");
        // Return a mock EventSource object that does nothing
        return {
          readyState: 0,
          close: function() { console.log("Mock EventSource closed"); },
          addEventListener: function() { console.log("Mock EventSource addEventListener (no-op)"); },
          removeEventListener: function() { console.log("Mock EventSource removeEventListener (no-op)"); },
          dispatchEvent: function() { console.log("Mock EventSource dispatchEvent (no-op)"); return true; }
        };
      }
    }
    
    // Safe to create real EventSource
    return new originalEventSource(url, options);
  };

  // --- Global User Status Variables (TA Mode always active) ---
  let isUserPremium = true;
  let isUserLoggedIn = true;

  // Variables for timed search status messages
  let statusMessageTimeouts = [];

  function removeStatusSpanText() {
    const statusSpan = document.querySelector('.search-status-text');
    if (statusSpan) {
      statusSpan.style.animation = 'none';
      statusSpan.style.opacity = '0';
      statusSpan.textContent = '';
    }
  }

  //Helper to get CSRF token reliably from DOM
  function getCsrfToken() {
    const csrfInput = document.querySelector('#search-form input[name="csrf_token"]') ||
                      document.querySelector('input[name="csrf_token"]');
    return csrfInput ? csrfInput.value : null;
  }

  const randomStatusMessages = [
    "Consulting Professor Nunn's course materials",
    "Reviewing Federal Rules of Evidence",
    "Checking class lecture slides & Socratic notes",
    "Cross-referencing course handouts & problems",
    "Synthesizing doctrinal framework",
    "Structuring step-by-step legal analysis",
    "Applying Professor Nunn's exam style guide",
    "Evaluating probative value vs. unfair prejudice",
    "Checking Advisory Committee Notes & case law",
    "Refining doctrinal walkthrough"
  ];

  // Ensure Pro Mode is set to true in localStorage
  const currentProMode = localStorage.getItem('proModeEnabled');
  if (currentProMode === null || currentProMode === 'false') {
    localStorage.setItem('proModeEnabled', 'true');
    console.log('Setting PRO mode to true on page load');
  }

  // ─────────────────────────────────────────────────────────────────────────────
  // Pro Search Toggle functionality
  // ─────────────────────────────────────────────────────────────────────────────
  const proModeToggleElement = document.querySelector('.pro-mode-toggle');
  const proModeToggleContainer = document.querySelector('.pro-mode-toggle-container');
  const logoProIndicator = document.querySelector('.logo-pro-indicator');

  // Initialize Pro Search state if we're already in chat mode
  if (document.querySelector('.container.chat-mode')) {
    // Check localStorage for saved preference, but always default to true if null or not set
    const savedProMode = localStorage.getItem('proModeEnabled');

    if (savedProMode === null) {
      localStorage.setItem('proModeEnabled', 'true');
      proModeEnabled = true;
    } else {
      proModeEnabled = savedProMode === 'true';

      // Force Pro Mode to true even if it was previously set to false
      // This ensures the website defaults to Pro Mode as requested
      if (!proModeEnabled) {
        proModeEnabled = true;
        localStorage.setItem('proModeEnabled', 'true');
      }
    }
  }

  // Initialize PRO mode indicators on page load
  if (proModeToggleElement) {
    console.log('[PRO Toggle Init] Found toggle element:', proModeToggleElement); // Log element found
    // Check localStorage for saved preference, but always default to true if null or not set
    const savedProMode = localStorage.getItem('proModeEnabled');
    console.log('[PRO Toggle Init] localStorage value:', savedProMode); // Log localStorage value

    if (savedProMode === null) {
      console.log('[PRO Toggle Init] No saved state, defaulting to true.'); // Log default
      localStorage.setItem('proModeEnabled', 'true');
      proModeEnabled = true;
    } else {
      console.log('[PRO Toggle Init] Found saved state:', savedProMode); // Log saved state
      proModeEnabled = savedProMode === 'true';

      // Force Pro Mode to true even if it was previously set to false
      // This ensures the website defaults to Pro Mode as requested
      if (!proModeEnabled) {
        proModeEnabled = true;
        localStorage.setItem('proModeEnabled', 'true');
      }
    }
    console.log('[PRO Toggle Init] Determined proModeEnabled:', proModeEnabled); // Log determined state

    // Update toggle and indicators based on current mode
    if (proModeEnabled) {
      console.log('[PRO Toggle Init] Setting toggle to ACTIVE.');
      proModeToggleElement.classList.add('active');

      // Show PRO mode notice
      const proModeNotice = document.querySelector('.pro-mode-notice');
      // REMOVED: Logic to make notice visible on initial load
      // if (proModeNotice) {
      //   proModeNotice.classList.add('visible');
      //   proModeNotice.style.opacity = '1';
      // }
    } else {
      console.log('[PRO Toggle Init] Setting toggle to INACTIVE.');
      proModeToggleElement.classList.remove('active');

      // Hide PRO mode notice
      const proModeNotice = document.querySelector('.pro-mode-notice');
      if (proModeNotice) {
        proModeNotice.classList.remove('visible');
        proModeNotice.style.opacity = '0';
      }
    }
    updateProIndicators(proModeEnabled);
  }

  // Fetch remaining PRO searches for non-premium users
  function updateRemainingProSearches() {
    fetch('/pro-search-remaining')
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then(data => {
        remainingProSearches = data.remaining;
        // Update global variable instead of defining local const
        isUserPremium = data.is_premium;
        const limit = data.limit; // Get the limit from the response
        
        // console.log('[Update Remaining] Data:', data); // Debug log

        if (!proModeToggleElement) return; // Exit if toggle element not found

        const tooltipElement = proModeToggleElement.querySelector('.pro-mode-tooltip');

        // Logic for enabling/disabling the toggle
        // Use the global isUserPremium variable here
        if (isUserPremium || remainingProSearches > 0) {
          // --- Enable Toggle ---
          // console.log('[Update Remaining] Enabling toggle.');
          proModeToggleElement.classList.remove('disabled');
          proModeToggleElement.title = "PRO Search enhances results with improved accuracy and includes sources beyond evidence law"; // Reset title
          if (tooltipElement) {
              // Reset tooltip text and ensure hover effect is disabled
              tooltipElement.textContent = `Try PRO Search with ${limit} free searches per day`;
              tooltipElement.classList.remove('show-on-hover');
          }
          
          // Ensure PRO mode is activated visually if enabled
          if (localStorage.getItem('proModeEnabled') === 'true') { 
            if (!proModeToggleElement.classList.contains('active')) {
              proModeToggleElement.classList.add('active');
            }
            updateProIndicators(true);
            // Ensure notice is visible
            // REMOVED: Logic to make notice visible here
            // const proModeNotice = document.querySelector('.pro-mode-notice');
            // if (proModeNotice) {
            //   proModeNotice.classList.add('visible');
            //   proModeNotice.style.opacity = '1';
            // }
          }
          
        } else {
          // --- Disable Toggle (Not premium AND 0 remaining searches) ---
          // console.log('[Update Remaining] Disabling toggle.');
          proModeToggleElement.classList.add('disabled');
          proModeToggleElement.title = "Daily PRO search limit reached"; // Update title
          if (tooltipElement) {
              // Update tooltip text and enable hover effect
              tooltipElement.textContent = "AI is expensive, so nunn.ai must unfortunately restrict users to 10 free PRO searches per day. For unlimited PRO searches, become a nunn.ai PRO supporter.";
              tooltipElement.classList.add('show-on-hover');
          }
          // Force toggle to CORE visually when disabled
          proModeToggleElement.classList.remove('active');
          updateProIndicators(false);
          localStorage.setItem('proModeEnabled', 'false');
          // Hide the pro mode notice as well
          const proModeNotice = document.querySelector('.pro-mode-notice');
           if (proModeNotice) {
                proModeNotice.classList.remove('visible');
                proModeNotice.style.opacity = '0';
           }
        }
      })
      .catch(error => {
        // console.error('Error fetching remaining PRO searches:', error);
        // Optionally handle the error in the UI, e.g., disable toggle as a precaution
        if (proModeToggleElement) {
            // proModeToggleElement.classList.add('disabled');
            // proModeToggleElement.title = "Could not check search limit";
        }
      });
  }

  // Function to update all TA indicators on the page
  function updateProIndicators(isActive) {
    const allProIndicators = document.querySelectorAll('.logo-pro-indicator:not(.upgrade-logo-pro-indicator):not(.upgrade-pro-indicator)');
    allProIndicators.forEach(indicator => {
      indicator.classList.add('active');
      indicator.textContent = 'TA';
    });
  }

  // --- Helper function for URL normalization ---
  function normalizeUrl(url) {
      if (!url) return url;
      try {
          const urlObj = new URL(url);
          // Remove common tracking parameters
          const paramsToRemove = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'fbclid', 'gclid'];
          paramsToRemove.forEach(param => urlObj.searchParams.delete(param));
          // Remove fragment
          urlObj.hash = '';
          // Remove trailing slash if path is not just '/'
          let normalized = urlObj.toString();
          if (urlObj.pathname && urlObj.pathname !== '/' && normalized.endsWith('/')) {
              normalized = normalized.slice(0, -1);
          }
          return normalized;
      } catch (e) {
          console.warn(`Failed to normalize URL: ${url}`, e);
          return url; // Return original if parsing fails
      }
  }

  // --- Title Fetching and Citation Enhancement --- 

  const POLLING_INTERVAL = 2000; // Poll every 2 seconds
  const POLLING_TIMEOUT = 30000; // Stop polling after 30 seconds

  async function startTitleCheckPolling(conversationId, messageElement) {
      console.log(`Starting title check polling for ConvID: ${conversationId}`);
      const startTime = Date.now();

      // Safety check: don't start polling if we don't have a valid conversation ID
      // This prevents accidental requests during page load that might trigger the /ask endpoint
      if (!conversationId || conversationId.length < 5) {
          console.warn("Invalid or missing conversation ID, skipping title check polling");
          return;
      }

      // Safety check: ensure we have a message element to update
      if (!messageElement || !messageElement.querySelector) {
          console.warn("Invalid message element, skipping title check polling");
          return;
      }

      const intervalId = setInterval(async () => {
          if (Date.now() - startTime > POLLING_TIMEOUT) {
              console.warn(`Polling timeout reached for ConvID: ${conversationId}`);
              clearInterval(intervalId);
              return;
          }

          try {
              const response = await fetch(`/check-titles/${conversationId}`);

              if (response.status === 200) {
                  const result = await response.json(); // <-- Get the full result object
                  const urlInfoList = result.url_info; // <-- Extract the list from url_info property
                  console.log(`Received title/status data (list) for ConvID ${conversationId}:`, urlInfoList); 
                  // Ensure urlInfoList is actually an array before proceeding
                  if (Array.isArray(urlInfoList)) {
                      clearInterval(intervalId); // Stop polling
                      enhanceCitations(urlInfoList, messageElement); // <-- Pass the extracted list
                  } else {
                      console.error(`Error: url_info is not an array in response for ConvID ${conversationId}:`, result);
                      clearInterval(intervalId); // Stop polling on data format error
                  }
              } else if (response.status === 204) {
                  console.log(`Titles/Status not ready for ConvID ${conversationId}, continuing poll...`); 
              } else if (response.status === 500) {
                   const errorData = await response.json();
                   // Log the partial results if available
                   console.error(`Error checking titles/status for ConvID ${conversationId}: ${errorData.error} (${errorData.details || 'No details'})`, errorData.partial_results);
                   clearInterval(intervalId); // Stop polling on error
                   // Optionally: Enhance citations with partial results from error?
                   // Note: errorData.partial_results might still be a map, need to handle if used
                   if (errorData.partial_results && typeof errorData.partial_results === 'object') {
                        console.log("Attempting to render partial results from error (converting map to list)...");
                        // Convert the map from error response back to a list for enhanceCitations
                        const partialList = [];
                        for (const norm_url in errorData.partial_results) {
                            partialList.push({
                                url: norm_url,
                                title: errorData.partial_results[norm_url]?.title,
                                status: errorData.partial_results[norm_url]?.status
                            });
                        }
                        // Sort the partial list as well
                        partialList.sort((a, b) => {
                            const titleA = a.title || '';
                            const titleB = b.title || '';
                            if (!titleA && titleB) return 1;
                            if (titleA && !titleB) return -1;
                            return titleA.toLowerCase().localeCompare(titleB.toLowerCase());
                        });
                        enhanceCitations(partialList, messageElement);
                   }
              } else {
                  console.warn(`Unexpected status code ${response.status} while polling for ConvID ${conversationId}`);
                   clearInterval(intervalId); // Stop polling on unexpected status
              }
          } catch (error) {
              console.error(`Error during polling request for ConvID ${conversationId}:`, error);
              clearInterval(intervalId); // Stop polling on fetch error
          }
      }, POLLING_INTERVAL);
  }

  function enhanceCitations(urlInfoList, messageElement) { // <-- Accept urlInfoList (now an array)
    // Check if the list is valid and has entries
    // Add detailed logging to pinpoint the failure
    if (!messageElement) {
        console.error("[enhanceCitations Check Fail] messageElement is missing or invalid.", messageElement);
        return;
    }
    if (!Array.isArray(urlInfoList)) {
        console.error("[enhanceCitations Check Fail] urlInfoList is not an array.", urlInfoList);
        return;
    }
    if (urlInfoList.length === 0) {
        console.warn("[enhanceCitations Check Fail] urlInfoList is empty.");
        return;
    }
    // Original combined check (can be removed if above logs are sufficient)
    // if (!messageElement || !Array.isArray(urlInfoList) || urlInfoList.length === 0) { 
    //     console.log("No valid URL info list found or message element missing, skipping citation enhancement.");
    //     return;
    // }

    // List is received directly (already sorted by the backend)
    console.log("Using received URL Info List directly for See Also:", urlInfoList);

    const contentDiv = messageElement.querySelector('.message-content');
    if (!contentDiv) return;

    console.log("Processing See Also section for message:", messageElement.id || messageElement);

    // --- REMOVED Steps 1 & 2 (Modifying existing links/plain text) ---

    // --- 3. Add/Update "See Also" section with ALL non-404 URLs ---
    let validUrlsCount = 0; // Count URLs that are not 404

    // Prepare list items first, *then* create/update the section if needed
    const listItems = [];
    urlInfoList.forEach(item => { // Iterate directly over the list
        const url = item.url; // Get the actual URL
        const title = item.title; // Get the title
        const status = item.status; // Get the status

        // Only include if status is known and NOT 404
        if (url && status !== 404) {
            validUrlsCount++;
            const listItem = document.createElement('li');
            const linkElement = document.createElement('a');

            linkElement.dataset.href = url;
            linkElement.role = 'link';
            linkElement.tabIndex = 0;
            linkElement.style.cursor = 'pointer';
            linkElement.classList.add('citation-link');
            linkElement.addEventListener('click', function(e) {
                e.preventDefault();
                window.open(this.dataset.href, '_blank', 'noopener,noreferrer');
            });

            // Set link text: Title if available, otherwise the URL
            const linkText = title ? title.trim() : url; // Use URL if title is missing
            linkElement.appendChild(document.createTextNode(linkText));

            listItem.appendChild(linkElement);
            listItems.push(listItem); // Add to temporary list
        } else {
            // Log excluded URLs (optional debugging)
            if (status === 404) {
                 console.log(`Excluding URL due to 404 status: ${url}`);
            } else {
                 console.log(`Excluding URL due to missing info or status: ${url}`, item);
            }
        }
    });

    // Only add/update the section if there are valid URLs to display
    if (validUrlsCount > 0) {
        console.log(`Rendering See Also section with ${validUrlsCount} valid URLs.`);
        let seeAlsoSection = contentDiv.querySelector('.see-also-section');
        let listElement;

        // Ensure section and list exist
        if (!seeAlsoSection) {
            seeAlsoSection = document.createElement('div');
            seeAlsoSection.classList.add('see-also-section');
            seeAlsoSection.innerHTML = '<strong class="section-heading">See Also</strong>'; 
            listElement = document.createElement('ul');
            seeAlsoSection.appendChild(listElement);
            contentDiv.appendChild(seeAlsoSection);
        } else {
            listElement = seeAlsoSection.querySelector('ul');
            if (!listElement) {
                 listElement = document.createElement('ul');
                 // Ensure list is appended if section exists but list doesn't
                 while (seeAlsoSection.firstChild) { // Clear potential old content besides heading
                      if (seeAlsoSection.firstChild.nodeName !== 'STRONG') {
                           seeAlsoSection.removeChild(seeAlsoSection.firstChild);
                      } else {
                           break; // Keep heading
                      }
                 }
                 seeAlsoSection.appendChild(listElement);
            }
            listElement.innerHTML = ''; // Clear previous list items
        }

        // Append the filtered list items
        listItems.forEach(item => listElement.appendChild(item));

        // Scroll to ensure visibility if needed (optional)
        if (typeof scrollToBottom === 'function') {
            // Maybe only scroll if the section was newly created?
            // scrollToBottom('chat-messages-wrapper'); 
        } else {
            console.warn("scrollToBottom function not found.");
        }
    } else {
         // If no *valid* URLs, remove existing See Also section
         let existingSection = contentDiv.querySelector('.see-also-section');
         if(existingSection) existingSection.remove();
         console.log("No valid (non-404) URLs found to add to See Also section.");
    }

    console.log("Citation enhancement finished (See Also only).");
  }

  // --- End Title Fetching and Citation Enhancement --- 

  if (proModeToggleElement) {
    // Always default to PRO mode
    localStorage.setItem('proModeEnabled', 'true');
    proModeEnabled = true;

    // Update toggle UI
    console.log('[PRO Toggle Init - Second Block] Setting initial UI state based on proModeEnabled:', proModeEnabled); // Log UI update
    if (!proModeToggleElement.classList.contains('active') && proModeEnabled) {
        console.log('[PRO Toggle Init - Second Block] Adding active class.');
        proModeToggleElement.classList.add('active');
    } else if (proModeToggleElement.classList.contains('active') && !proModeEnabled) {
        console.log('[PRO Toggle Init - Second Block] Removing active class.');
        proModeToggleElement.classList.remove('active');
    }

    // Make sure PRO mode notice is visible
    // REMOVED: Logic to make notice visible on initial load
    // const proModeNotice = document.querySelector('.pro-mode-notice');
    // if (proModeNotice) {
    //   proModeNotice.classList.add('visible');
    //   proModeNotice.style.opacity = '1';
    // }

    // Add click event listener to toggle
    proModeToggleElement.addEventListener('click', function() {
      console.log('[PRO Toggle Click] Click detected. Disabled:', this.classList.contains('disabled')); // Log click
      // Only allow toggling if not disabled
      if (!this.classList.contains('disabled')) {
        console.log('[PRO Toggle Click] Toggle is NOT disabled.');
        // Toggle active state
        if (this.classList.contains('active')) {
          console.log('[PRO Toggle Click] Was active, removing active class.');
          this.classList.remove('active');
          proModeEnabled = false;
          const proModeNotice = document.querySelector('.pro-mode-notice');
          if (proModeNotice) {
            // Fade out the notice with a transition (opacity only)
            proModeNotice.style.opacity = '0';
            proModeNotice.style.transition = 'opacity 0.3s ease';
            proModeNotice.style.transform = 'none'; // Ensure no transform is applied
            // After the transition, remove the visible class
            setTimeout(() => {
              proModeNotice.classList.remove('visible');
            }, 300);
          }
          updateChatProModeNotice(false);
        } else {
          console.log('[PRO Toggle Click] Was NOT active, adding active class.');
          this.classList.add('active');
          proModeEnabled = true;
          const proModeNotice = document.querySelector('.pro-mode-notice');
          if (proModeNotice) {
            // Only show notice if already in chat mode
            if (inChatMode) {
              // Make sure it's in the DOM first
              proModeNotice.classList.add('visible');
              proModeNotice.style.transform = 'none'; // Ensure no transform is applied
              // Then fade it in
              setTimeout(() => {
                proModeNotice.style.opacity = '1';
                proModeNotice.style.transition = 'opacity 0.3s ease';
              }, 10);
            } else {
              // If not in chat mode, ensure it's hidden
              proModeNotice.classList.remove('visible');
              proModeNotice.style.opacity = '0';
            }
          }
          updateChatProModeNotice(true);
        }

        // Save state to localStorage
        console.log('[PRO Toggle Click] Saving to localStorage:', proModeEnabled);
        localStorage.setItem('proModeEnabled', proModeEnabled);

        // Update PRO indicators
        console.log('[PRO Toggle Click] Updating indicators.');
        updateProIndicators(proModeEnabled);

        console.log('[PRO Toggle Click] New PRO Search mode:', proModeEnabled ? 'Enabled' : 'Disabled');
      } else {
         console.log('[PRO Toggle Click] Toggle IS disabled, doing nothing.');
      }
    });

    // Fetch remaining PRO searches on page load
    updateRemainingProSearches();
  }

  // Function to update the chat PRO mode notice visibility
  function updateChatProModeNotice(isVisible) {
    // In chat mode, we need to ensure the Pro notice visibility is properly managed
    if (inChatMode) {
      // Look for the pro-mode-notice in the search-interface
      const proModeNotice = document.querySelector('.search-interface .pro-mode-notice');
      if (proModeNotice) {
        if (isVisible) {
          proModeNotice.classList.add('visible');
          // Ensure no transform is applied
          proModeNotice.style.transform = 'none';
          // Initially set opacity to 0 so it can fade in later
          proModeNotice.style.opacity = '0';
          // Set transition for smooth fade-in
          proModeNotice.style.transition = 'opacity 2s ease-in';
          // Fade in after a small delay
          setTimeout(() => {
            proModeNotice.style.opacity = '1';
          }, 10);
        } else {
          // Fade out with transition
          proModeNotice.style.opacity = '0';
          proModeNotice.style.transition = 'opacity 2s ease-in';
          proModeNotice.style.transform = 'none'; // Ensure no transform is applied
          // Remove visible class after transition
          setTimeout(() => {
            proModeNotice.classList.remove('visible');
          }, 2000);
        }
      }
    }
  }

  // ─────────────────────────────────────────────────────────────────────────────
  // File upload functionality
  // ─────────────────────────────────────────────────────────────────────────────
  const searchAttachButton = document.getElementById('search-attach-button');
  const searchFileInput = document.getElementById('search-file-input');
  const searchFilePreview = document.getElementById('search-file-preview');

  // Attach click handler to the paper clip button
  if (searchAttachButton) {
    searchAttachButton.addEventListener('click', (e) => {
      e.preventDefault();
      if (searchFileInput) {
        if (!searchFileInput.files || searchFileInput.files.length === 0) {
          searchFileInput.value = '';
        }
        searchFileInput.click();
      }
    });
  }

  // Handle file selection
  if (searchFileInput) {
    searchFileInput.addEventListener('change', () => {
      if (searchFileInput.files.length > 0) {
        // Clear previous preview
        searchFilePreview.innerHTML = '';

        // Show the preview container
        searchFilePreview.style.display = 'block';

        // Add each file to the preview
        Array.from(searchFileInput.files).forEach(file => {
          const fileItem = document.createElement('div');
          fileItem.className = 'search-file-item';

          const fileIcon = getFileIcon(file.name);

          fileItem.innerHTML = `
            <div class="search-file-name">
              <i class="${fileIcon}"></i> ${file.name}
            </div>
            <button class="search-remove-file" data-name="${file.name}" aria-label="Remove file">
              <i class="fas fa-times"></i>
            </button>
          `;

          searchFilePreview.appendChild(fileItem);
        });

        // Add event listeners to remove buttons
        document.querySelectorAll('.search-remove-file').forEach(button => {
          button.addEventListener('click', (e) => {
            e.preventDefault();
            const fileName = button.getAttribute('data-name');
            const dt = new DataTransfer();

            // Keep all files except the one to remove
            Array.from(searchFileInput.files)
              .filter(file => file.name !== fileName)
              .forEach(file => dt.items.add(file));

            searchFileInput.files = dt.files;

            // Remove the file item from preview
            button.closest('.search-file-item').remove();

            // Hide preview if no files left
            if (searchFileInput.files.length === 0) {
              searchFilePreview.style.display = 'none';
            }
          });
        });
      } else {
        // No files selected, hide preview
        searchFilePreview.style.display = 'none';
      }
    });
  }

  // ─────────────────────────────────────────────────────────────────────────────
  // Chat file upload functionality
  // ─────────────────────────────────────────────────────────────────────────────
  const chatAttachButton = document.getElementById('chat-attach-button');
  const chatFileInput = document.getElementById('chat-file-input');
  const chatFilePreview = document.getElementById('chat-file-preview');

  // Attach click handler to the chat paper clip button
  if (chatAttachButton) {
    chatAttachButton.addEventListener('click', (e) => {
      e.preventDefault();
      if (chatFileInput) {
        if (!chatFileInput.files || chatFileInput.files.length === 0) {
          chatFileInput.value = '';
        }
        chatFileInput.click();
      }
    });
  }

  // Handle chat file selection
  if (chatFileInput) {
    chatFileInput.addEventListener('change', () => {
      if (chatFileInput.files.length > 0) {
        // Clear previous preview
        chatFilePreview.innerHTML = '';

        // Show the preview container
        chatFilePreview.style.display = 'block';

        // Add each file to the preview
        Array.from(chatFileInput.files).forEach(file => {
          const fileItem = document.createElement('div');
          fileItem.className = 'chat-file-item';

          const fileIcon = getFileIcon(file.name);

          fileItem.innerHTML = `
            <div class="chat-file-name">
              <i class="${fileIcon}"></i> ${file.name}
            </div>
            <button class="chat-remove-file" data-name="${file.name}" aria-label="Remove file">
              <i class="fas fa-times"></i>
            </button>
          `;

          chatFilePreview.appendChild(fileItem);
        });

        // Add event listeners to remove buttons
        document.querySelectorAll('.chat-remove-file').forEach(button => {
          button.addEventListener('click', (e) => {
            e.preventDefault();
            const fileName = button.getAttribute('data-name');
            const dt = new DataTransfer();

            // Keep all files except the one to remove
            Array.from(chatFileInput.files)
              .filter(file => file.name !== fileName)
              .forEach(file => dt.items.add(file));

            chatFileInput.files = dt.files;

            // Remove the file item from preview
            button.closest('.chat-file-item').remove();

            // Hide preview if no files left
            if (chatFileInput.files.length === 0) {
              chatFilePreview.style.display = 'none';
            }
          });
        });
      } else {
        // No files selected, hide preview
        chatFilePreview.style.display = 'none';
      }
    });
  }

  // Helper function to get appropriate icon for file type
  function getFileIcon(filename) {
    const extension = filename.split('.').pop().toLowerCase();

    if (['pdf'].includes(extension)) {
      return 'fas fa-file-pdf';
    } else if (['doc', 'docx', 'pages', 'rtf', 'odt'].includes(extension)) {
      return 'fas fa-file-word';
    } else if (['xls', 'xlsx', 'csv'].includes(extension)) {
      return 'fas fa-file-excel';
    } else if (['ppt', 'pptx'].includes(extension)) {
      return 'fas fa-file-powerpoint';
    } else if (['jpg', 'jpeg', 'png', 'gif', 'bmp', 'svg', 'webp'].includes(extension)) {
      return 'fas fa-file-image';
    } else if (['zip', 'rar', '7z', 'tar', 'gz'].includes(extension)) {
      return 'fas fa-file-archive';
    } else if (['mp3', 'wav', 'ogg'].includes(extension)) {
      return 'fas fa-file-audio';
    } else if (['mp4', 'avi', 'mov', 'wmv'].includes(extension)) {
      return 'fas fa-file-video';
    } else if (['html', 'htm', 'xml'].includes(extension)) {
      return 'fas fa-file-code';
    } else if (['txt', 'md'].includes(extension)) {
      return 'fas fa-file-alt';
    } else {
      return 'fas fa-file';
    }
  }

  // ─────────────────────────────────────────────────────
  // 1) Check for follow-up data
  //    We unify references so it behaves as "Continue Chat."
  // ─────────────────────────────────────────────────────
  function checkFollowUpData() {
    console.log("Checking for follow-up data...");
    const followUpData = document.getElementById('follow-up-data');
    if (followUpData) {
      console.log("Found follow-up data element");
      // If a data-question was passed in, treat it as continuing the chat
      const followUpQuestion = followUpData.getAttribute('data-question');
      if (followUpQuestion) {
        console.log("Found follow-up question:", followUpQuestion);
        const questionInput = document.getElementById('question');
        if (questionInput) {
          questionInput.value = followUpQuestion;
          // Instead of "Ask a follow-up question...", unify it:
          questionInput.placeholder = "Continue the conversation...";
          // If you want to keep the original .follow-up-mode style, that's fine:
          questionInput.classList.add('continue-chat-mode');
          adjustTextareaHeight(questionInput);
        }

        // If conversation ID is available, store it
        const conversationId = followUpData.getAttribute('data-conversation-id');
        if (conversationId) {
          console.log("Found conversation ID:", conversationId);
          currentConversationId = conversationId;
        }

        // Update the search button to "Continue Chat" mode
        const searchButton = document.getElementById("askButton");
        if (searchButton) {
          searchButton.innerHTML = "<i class='fas fa-comment-dots'></i> Continue Chat";
          searchButton.classList.remove('new-search-mode');
          searchButton.classList.add('continue-chat-mode');
        }

        // Auto-submit question after short delay
        console.log("Setting timeout to auto-submit (continue chat) question");
        setTimeout(() => {
          console.log("Auto-submitting question in 'continue chat' mode");
          handleSearch();
        }, 500);
      } else {
        console.log("No follow-up question found in data element");
      }
    } else {
      console.log("No follow-up data element found");
    }
  }

  // ─────────────────────────────────────────────────────
  // 2) Check for overlap between notice and userNav
  //    (Unchanged logic)
  // ─────────────────────────────────────────────────────
  function checkOverlap() {
    const notice = document.querySelector('.version-notice');
    const userNav = document.querySelector('.user-nav');

    if (!notice || !userNav) return;

    const noticeRect = notice.getBoundingClientRect();
    const userNavRect = userNav.getBoundingClientRect();

    const horizontalOverlap = !(
      noticeRect.right < userNavRect.left ||
      noticeRect.left > userNavRect.right
    );

    const verticalOverlap = !(
      noticeRect.bottom < userNavRect.top ||
      noticeRect.top > userNavRect.bottom
    );

    if (horizontalOverlap && verticalOverlap) {
      notice.classList.add('fade');
    } else {
      notice.classList.remove('fade');
    }
  }
  checkOverlap();
  window.addEventListener('resize', checkOverlap);

  // ─────────────────────────────────────────────────────
  // 3) Adjust textarea height cleanly without single-line scrollbar
  // ─────────────────────────────────────────────────────
  function adjustTextareaHeight(textarea) {
    if (!textarea) return;
    textarea.style.height = '42px';
    const val = textarea.value || '';
    const scrollHeight = textarea.scrollHeight;
    const maxHeight = parseInt(getComputedStyle(textarea).maxHeight) || 140;

    if (!val || (!val.includes('\n') && scrollHeight <= 52)) {
      textarea.style.height = '42px';
      textarea.style.overflowY = 'hidden';
    } else if (scrollHeight > 42) {
      const nextHeight = Math.min(scrollHeight, maxHeight);
      textarea.style.height = nextHeight + 'px';
      textarea.style.overflowY = scrollHeight > maxHeight ? 'auto' : 'hidden';
    }
  }

  // ─────────────────────────────────────────────────────
  // 4) Format response text (Structured Markdown Parser)
  // ─────────────────────────────────────────────────────
  function formatInlineMarkdown(str) {
    if (!str) return '';
    let s = str;

    // 1. Inline code (`code`)
    s = s.replace(/`([^`\n]+)`/g, '<code>$1</code>');

    // 2. Bold + Italic (***text***)
    s = s.replace(/\*\*\*([^\*\n]+?)\*\*\*/g, '<strong class="section-heading"><em>$1</em></strong>');

    // 3. Bold (**text**)
    s = s.replace(/\*\*([^\n]+?)\*\*/g, '<strong class="section-heading">$1</strong>');

    // 4. Markdown links [text](url)
    s = s.replace(
      /\[([^\]]+)\]\(([^)]+)\)/g,
      '<a data-href="$2" role="link" tabindex="0" class="citation-link" onclick="window.open(this.dataset.href,\'_blank\',\'noopener,noreferrer\');return false;">$1</a>'
    );

    // 5. Bare URLs
    s = s.replace(
      /(^|\s|>)(https?:\/\/[^\s<]+)(?=$|\s|<)/g,
      '$1<a data-href="$2" role="link" tabindex="0" class="citation-link" onclick="window.open(this.dataset.href,\'_blank\',\'noopener,noreferrer\');return false;">$2</a>'
    );

    // 6. Single-line Italics (*text*) — never spans across newlines or list bullets
    s = s.replace(/(^|[^\*])\*([^\s\*][^\*\n]*?[^\s\*]|[^\s\*])\*(?!\*)/g, '$1<em>$2</em>');

    return s;
  }

  function formatResponseText(text) {
    if (!text) return '';

    // Fix character encoding issues first
    text = text.replace(/\u00e2\u0080\u0094/g, '\u2014');  // Fix em dash
    text = text.replace(/\u00e2\u0080\u0098/g, '\u2018');  // Fix single opening quote
    text = text.replace(/\u00e2\u0080\u0099/g, '\u2019');  // Fix single closing quote
    text = text.replace(/\u00e2\u0080\u009c/g, '\u201c');  // Fix double opening quote
    text = text.replace(/\u00e2\u0080\u009d/g, '\u201d');  // Fix double closing quote
    text = text.replace(/\u00e2\u0080\u00a6/g, '\u2026');  // Fix ellipsis
    text = text.replace(/\u00e2\u0080\u0093/g, '\u2013');  // Fix en dash
    text = text.replace(/\u00f4\u0080/g, '');
    text = text.replace(/\r\n|\r/g, '\n');

    // Separate Citations section if present
    let citationsHtml = '';
    const citationHeaderRegex = /(?:^|\n)(\*{2}Citations\*{2}|#{1,4}\s*Citations|Citations)\s*\n/i;
    const match = text.match(citationHeaderRegex);

    if (match) {
      const splitIndex = match.index + match[0].length;
      const mainContent = text.substring(0, match.index);
      let citationContent = text.substring(splitIndex).trim();

      citationContent = citationContent.replace(
        /\[([^\]]+)\]\(([^)]+)\)/g,
        '<a data-href="$2" role="link" tabindex="0" class="citation-link" onclick="window.open(this.dataset.href,\'_blank\',\'noopener,noreferrer\');return false;">$1</a>'
      );
      citationContent = citationContent.replace(
        /(available at )(https?:\/\/[^\s\n]+)/g,
        (m, prefix, url) => `${prefix}<a data-href="${url}" role="link" tabindex="0" class="citation-link" onclick="window.open(this.dataset.href,'_blank','noopener,noreferrer');return false;">${url}</a>`
      );

      const citationLines = citationContent.split('\n').filter(line => line.trim() !== '');
      let processedCitationHTML = '';
      citationLines.forEach(line => {
        const trimmedLine = line.trim().replace(/^[-*•]\s+/, '');
        if (trimmedLine) {
          processedCitationHTML += `<li>${formatInlineMarkdown(trimmedLine)}</li>`;
        }
      });

      if (processedCitationHTML) {
        citationsHtml =
          '<div class="citations-section">' +
          '<strong class="section-heading">Citations</strong>' +
          `<ul>${processedCitationHTML}</ul>` +
          '</div>';
      }
      text = mainContent;
    }

    // Pre-split inline bold callouts like "Textualist View:" / "Purposivist View:" onto their own lines
    // when they appear mid-paragraph after a sentence end so long comparisons breathe cleanly.
    text = text.replace(/([.!?”"])\s+(\*\*(?:Textualist\s+View|Purposivist\s+View|Step\s+\d+[^*]*|Rule\s+\d+[^*]*Balance|Unprompted\s+Rule\s+403[^*]*|Exam\s+Takeaway|Bottom\s+Line|Conclusion|Holding|Facts|Issue|Analysis)[^*]*\*\*)/gi, '$1\n\n$2');

    const rawLines = text.split('\n');
    const htmlBlocks = [];
    let currentParagraph = [];
    let currentListType = null; // 'ul' or 'ol'
    let currentListItems = [];
    let currentBlockquote = [];

    function flushParagraph() {
      if (currentParagraph.length > 0) {
        const joined = currentParagraph.map(l => formatInlineMarkdown(l)).join('<br>');
        htmlBlocks.push(`<p>${joined}</p>`);
        currentParagraph = [];
      }
    }

    function flushList() {
      if (currentListItems.length > 0 && currentListType) {
        htmlBlocks.push(`<${currentListType} class="response-list">${currentListItems.join('')}</${currentListType}>`);
        currentListItems = [];
        currentListType = null;
      }
    }

    function flushBlockquote() {
      if (currentBlockquote.length > 0) {
        const joined = currentBlockquote.map(l => formatInlineMarkdown(l)).join('<br>');
        htmlBlocks.push(`<blockquote class="response-blockquote">${joined}</blockquote>`);
        currentBlockquote = [];
      }
    }

    function flushAll() {
      flushParagraph();
      flushList();
      flushBlockquote();
    }

    for (let i = 0; i < rawLines.length; i++) {
      const rawLine = rawLines[i];
      const trimmed = rawLine.trim();

      // Blank line
      if (!trimmed) {
        flushAll();
        continue;
      }

      // Horizontal rule (--- or ===)
      if (/^(?:---+|\*\*\*+|===+)$/.test(trimmed)) {
        flushAll();
        htmlBlocks.push('<hr class="response-divider">');
        continue;
      }

      // Markdown headings (# through ####)
      const headingMatch = trimmed.match(/^(#{1,4})\s+(.*?)$/);
      if (headingMatch) {
        flushAll();
        const level = Math.min(4, headingMatch[1].length);
        const headingText = formatInlineMarkdown(headingMatch[2].trim());
        htmlBlocks.push(`<h${level}>${headingText}</h${level}>`);
        continue;
      }

      // Standalone numbered section heading like "1. **The Hearsay Definition...**" or "I. **Overview**"
      const numberedHeadingMatch = trimmed.match(/^((?:\d+|[IVX]+)\.)\s+\*\*([^*]+)\*\*\s*(.*)$/);
      if (numberedHeadingMatch && !numberedHeadingMatch[3]) {
        flushAll();
        const hContent = `${numberedHeadingMatch[1]} ${formatInlineMarkdown(numberedHeadingMatch[2])}`;
        htmlBlocks.push(`<h3>${hContent}</h3>`);
        continue;
      }

      // Blockquote (> text)
      const bqMatch = trimmed.match(/^>\s?(.*)$/);
      if (bqMatch) {
        flushParagraph();
        flushList();
        currentBlockquote.push(bqMatch[1]);
        continue;
      } else if (currentBlockquote.length > 0) {
        flushBlockquote();
      }

      // Unordered list item (- item, * item, • item)
      const ulMatch = rawLine.match(/^(\s*)([-*•])\s+(.*)$/);
      if (ulMatch) {
        flushParagraph();
        const indentSpaces = ulMatch[1].length;
        const itemContent = formatInlineMarkdown(ulMatch[3].trim());
        if (currentListType && currentListType !== 'ul') {
          flushList();
        }
        currentListType = 'ul';
        const subClass = indentSpaces >= 2 ? ' class="response-subitem"' : '';
        currentListItems.push(`<li${subClass}>${itemContent}</li>`);
        continue;
      }

      // Ordered list item (1. item, 2) item)
      const olMatch = rawLine.match(/^(\s*)(\d+[\.\)])\s+(.*)$/);
      if (olMatch) {
        flushParagraph();
        const indentSpaces = olMatch[1].length;
        const itemContent = formatInlineMarkdown(olMatch[3].trim());
        if (currentListType && currentListType !== 'ol') {
          flushList();
        }
        currentListType = 'ol';
        const subClass = indentSpaces >= 2 ? ' class="response-subitem"' : '';
        currentListItems.push(`<li${subClass}><span class="ol-num">${olMatch[2]}</span> ${itemContent}</li>`);
        continue;
      }

      // If we were inside a list and hit a normal paragraph line:
      if (currentListType) {
        flushList();
      }

      // If a new line starts with a bold label (**Label:**), start a fresh paragraph
      if (/^\*\*[^*]{2,60}:\*\*/.test(trimmed) && currentParagraph.length > 0) {
        flushParagraph();
      }

      currentParagraph.push(trimmed);
    }

    flushAll();

    if (citationsHtml) {
      htmlBlocks.push(citationsHtml);
    }

    return htmlBlocks.join('\n');
  }

  // Utility function to scroll to bottom
  function scrollToBottom(elementId) {
      const chatMessages = document.getElementById('chat-messages');
      const element = chatMessages || document.getElementById(elementId);
      if (element) {
          element.scrollTo({ top: element.scrollHeight, behavior: 'auto' }); 
      }
  }

  // --- Helper function to process the response stream ---
  async function processStream(response, aiMessageElement) { 
      console.log("Starting stream processing helper... Target element:", aiMessageElement);
      let reader;
      const decoder = new TextDecoder();
      let buffer = ''; // Buffer for partial events
      
      // Get the content div *from the passed element*
      const contentDiv = aiMessageElement?.querySelector('.message-content');

      // Keep the typing indicator & status message visible during Argon reasoning
      // until the first 'message' event chunk arrives.
      if (contentDiv) {
        aiMessageElement.dataset.rawData = '';
      } else {
        console.error("processStream: Could not find contentDiv in the provided aiMessageElement!", aiMessageElement);
        addErrorMessage("Internal Error: Failed to display AI response.");
        return; // Stop processing
      }

      try {
          reader = response.body.getReader();

          while (true) {
              const { done, value } = await reader.read();
              if (done) {
                  console.log('Stream reading loop finished (done=true).');
                  // Process any remaining buffer content
                  if (buffer.trim()) {
                      buffer += '\n\n';
                      let prevBuffer;
                      do {
                          prevBuffer = buffer;
                          buffer = processBufferForEvents(buffer, contentDiv, aiMessageElement);
                      } while (buffer.trim() && buffer.length < prevBuffer.length);
                  }
                  break; // Exit loop
              }

              buffer += decoder.decode(value, { stream: true });

              // Process buffer for complete SSE events
              buffer = processBufferForEvents(buffer, contentDiv, aiMessageElement);
              
          } // End while loop
      } catch (streamError) {
          console.error("Error reading stream:", streamError);
          if (contentDiv) {
              aiMessageElement.classList.remove('typing-message');
              contentDiv.innerHTML = `<div class="error-message">[Stream Error: ${streamError.message}]</div>`;
          }
      } finally {
          console.log("Stream reader processing done (in helper finally block).");
          
          if (statusIntervalId) {
              clearInterval(statusIntervalId);
              statusIntervalId = null;
          }
          removeStatusSpanText();
          if (aiMessageElement) {
              aiMessageElement.classList.remove('typing-message');
              aiMessageElement.classList.remove('streaming');
          }
          removeFinalTypingIndicator(contentDiv);
          
          // --- Format the complete response --- 
          if (contentDiv && aiMessageElement) {
            const finalRawText = aiMessageElement.dataset.rawData || '';
            if (finalRawText) {
              const formattedHtml = formatResponseText(finalRawText);
              contentDiv.innerHTML = formattedHtml;
            }
          }
          // --- End Formatting ---

          // Add Action Buttons (Copy/Retry) if they don't exist
          addActionButtonsIfMissing(aiMessageElement);

          // Start title polling *after* stream is fully processed and buttons added
          if (currentConversationId && aiMessageElement) {
              startTitleCheckPolling(currentConversationId, aiMessageElement);
          }

          // Reset fetching state AFTER stream processing is fully complete
          isFetching = false;
          isStreaming = false;

          // Re-enable chat send button AFTER stream processing is fully complete
          const chatSendButton = document.getElementById('chat-send-button');
          if (chatSendButton) {
              chatSendButton.disabled = false;
              chatSendButton.innerHTML = "<i class='fas fa-comment-dots'></i> Continue Chat";
          }

          // Focus the chat input again
          const chatInput = document.getElementById('chat-input');
          if (chatInput) chatInput.focus();
          checkForMoreContent();
      }
      
      console.log("processStream helper finished.");
  }

  // Helper function to process the buffer for SSE events
  function processBufferForEvents(buffer, contentDiv, aiMessageElement) {
      // Use regex to find SSE event boundary (CRLF or LF)
      const boundaryRegex = /\r?\n\r?\n/;
      let match;
      while ((match = boundaryRegex.exec(buffer)) !== null) {
          const boundary = match.index;
          const delimLength = match[0].length;

          const eventString = buffer.slice(0, boundary);
          const remainingBuffer = buffer.slice(boundary + delimLength);

          // Skip empty blocks
          if (!eventString.trim()) {
              buffer = remainingBuffer;
              continue;
          }

          // --- Correct SSE Parsing Logic ---
          let eventType = 'message'; // Default event type
          let dataContent = '';
          const lines = eventString.split('\n');

          lines.forEach(line => {
              if (line.startsWith('event:')) {
                  eventType = line.substring(6).trim();
              } else if (line.startsWith('data:')) {
                  // Accumulate data lines (usually only one per event string block)
                  dataContent += line.substring(5).trim();
              }
          });

          // Allow 'end' event with no data, otherwise require data
          if (!dataContent && eventType !== 'end') {
              buffer = remainingBuffer;
              return buffer;
          }

          try {
              let parsedData = {};
              if (dataContent) {
                 parsedData = JSON.parse(dataContent);
              } else if (eventType === 'end') {
                 parsedData = {};
              } else {
                 buffer = remainingBuffer;
                 return buffer;
              }

              // Handle different event types based on the extracted 'eventType'
              switch (eventType) {
                  case 'message':
                    const messageChunk = parsedData.data;
                    if (contentDiv && typeof messageChunk === 'string') {
                      if (aiMessageElement.classList.contains('typing-message')) {
                        if (statusIntervalId) {
                          clearInterval(statusIntervalId);
                          statusIntervalId = null;
                        }
                        aiMessageElement.classList.remove('typing-message');
                        contentDiv.innerHTML = '';
                      }
                      // Update raw data buffer
                      const raw = (aiMessageElement.dataset.rawData || '') + messageChunk;
                      aiMessageElement.dataset.rawData = raw;
                      // Apply incremental Markdown formatting
                      contentDiv.innerHTML = formatResponseText(raw);
                      scrollToBottom('chat-messages');
                    }
                    break;
                  case 'info':
                      const infoMsg = parsedData.message;
                      if (contentDiv && typeof infoMsg === 'string') {
                          const statusSpan = getOrCreateStatusSpan();
                          if (statusSpan) {
                              statusSpan.textContent = infoMsg;
                          }
                      }
                      break;
                  case 'sources':
                      if (aiMessageElement && parsedData.urls && Array.isArray(parsedData.urls)) {
                          aiMessageElement.dataset.sourceUrls = JSON.stringify(parsedData.urls);
                      }
                      break;
                  case 'timing':
                      break;
                  case 'error':
                      console.error(`[SSE ProcessBuffer] Event 'error' from backend:`, parsedData);
                      const errorMsg = parsedData.message;
                      if (contentDiv && typeof errorMsg === 'string') {
                          if (statusIntervalId) {
                              clearInterval(statusIntervalId);
                              statusIntervalId = null;
                          }
                          aiMessageElement.classList.remove('typing-message');
                          removeFinalTypingIndicator(contentDiv);
                          const errorElement = document.createElement('div');
                          errorElement.className = 'error-message';
                          errorElement.textContent = `[Backend Error: ${errorMsg}]`;
                          contentDiv.innerHTML = '';
                          contentDiv.appendChild(errorElement);
                          scrollToBottom('chat-messages');
                      }
                      break;
                  case 'end':
                      break;
                  default:
                      console.warn(`[SSE ProcessBuffer] Event has unknown type: ${eventType}`);
              }
          } catch (parseError) {
              // FIX: Treat all SyntaxError during parsing as likely partial JSON chunk and defer further processing
              if (parseError instanceof SyntaxError) {
                  console.warn(`[SSE ProcessBuffer] Partial JSON chunk detected (${parseError.message}), deferring until more data arrives.`);
                  break; // Exit event processing loop, preserving buffer for next data
              } else {
                  // Log other parsing errors more seriously.
                  console.error(`[SSE ProcessBuffer] Failed JSON parsing:`, parseError);
                  console.error("[SSE ProcessBuffer] Invalid JSON data string was:", dataContent);
                  if (contentDiv) {
                      removeFinalTypingIndicator(contentDiv); // Clean up indicator on significant error
                  }
              }
          }
          // MODIFICATION: Update buffer after processing/skipping OR error handling (unless error should halt all)
          buffer = remainingBuffer;
          // console.log(`[SSE ProcessBuffer] After processing event ${eventCounter}, remaining buffer length: ${buffer.length}`); // DIAG REMOVED


      } // End while loop (event processing)

      return buffer; // Return the remaining unprocessed buffer content
  }
  
  // Helper to remove the final typing indicator
  function removeFinalTypingIndicator(contentDiv) {
       if (contentDiv && contentDiv.innerHTML.endsWith('<div class="typing-indicator"></div>')) {
          // console.log("Removing typing indicator"); // Can be noisy
          contentDiv.innerHTML = contentDiv.innerHTML.replace(/<div class="typing-indicator"><\/div>$/, ''); // Corrected regex escaping
      }
  }
  
  // Helper to add the final typing indicator
  function addFinalTypingIndicator(contentDiv) {
      if (contentDiv && !contentDiv.innerHTML.endsWith('<div class="typing-indicator"></div>')) {
          // console.log("Adding typing indicator"); // Can be noisy
          contentDiv.innerHTML += '<div class="typing-indicator"></div>';
      }
  }

  // Helper to add action buttons (extracted logic)
  function addActionButtonsIfMissing(messageElement) {
     if (messageElement && !messageElement.querySelector('.message-actions')) {
          console.log("[Action Buttons] Adding action buttons to message.");
          const messageActions = document.createElement('div');
          messageActions.className = 'message-actions';
          
          // Add copy button
          const copyButton = document.createElement('button');
          copyButton.className = 'message-action-btn copy-btn';
          copyButton.innerHTML = '<i class="fas fa-copy"></i>';
          copyButton.setAttribute('aria-label', 'Copy message');
          copyButton.setAttribute('title', 'Copy message');
          
          const contentDivForCopy = messageElement.querySelector('.message-content');
          copyButton.addEventListener('click', () => {
              if (!contentDivForCopy) return;
              const textToCopy = contentDivForCopy.innerText || contentDivForCopy.textContent;
              navigator.clipboard.writeText(textToCopy)
                  .then(() => {
                      copyButton.innerHTML = '<i class="fas fa-check"></i>';
                      setTimeout(() => {
                          copyButton.innerHTML = '<i class="fas fa-copy"></i>';
                      }, 2000);
                  })
                  .catch(err => {
                      console.error('Failed to copy text: ', err);
                  });
          });
          messageActions.appendChild(copyButton);
          
          // Add retry button (only makes sense for AI messages preceded by user messages)
          if (messageElement.classList.contains('ai')) {
              const retryButton = document.createElement('button');
              retryButton.className = 'message-action-btn retry-btn';
              retryButton.innerHTML = '<i class="fas fa-redo-alt"></i>';
              retryButton.setAttribute('aria-label', 'Retry message');
              retryButton.setAttribute('title', 'Retry message');
              
              let precedingUserMessage = messageElement.previousElementSibling;
              while (precedingUserMessage && !precedingUserMessage.classList.contains('user')) {
                  precedingUserMessage = precedingUserMessage.previousElementSibling;
              }
              
              if (precedingUserMessage) {
                  retryButton.addEventListener('click', () => {
                      const userContentDiv = precedingUserMessage.querySelector('.message-content');
                      const userContent = userContentDiv ? userContentDiv.textContent : '';
                      const chatInput = document.getElementById('chat-input');
                      if (chatInput && userContent) {
                          chatInput.value = userContent;
                          adjustTextareaHeight(chatInput);
                          const sendButton = document.getElementById('chat-send-button');
                          if (sendButton) {
                              sendButton.click();
                          }
                      } else {
                         console.warn("Could not find user content or chat input for retry.");
                      }
                  }); // Closing parenthesis for event listener
              } else {
                   console.warn("Could not find preceding user message for retry button.");
                   retryButton.disabled = true; // Disable if no user message found
              } // Closing brace for if(precedingUserMessage)
              messageActions.appendChild(retryButton);
          } // Closing brace for if(messageElement.classList.contains('ai'))
          
          // Append actions to the main message div
          messageElement.appendChild(messageActions);
      } // Closing brace for if(messageElement && !messageElement.querySelector...)
  } // Closing brace for function addActionButtonsIfMissing

  // ─────────────────────────────────────────────────────
  // 5) Fade in/out effects (unchanged)
  // ─────────────────────────────────────────────────────
  function fadeInEffect(element, formattedText, duration = 2000) {
    element.style.opacity = '0';
    element.innerHTML = formattedText;
    element.offsetHeight; // trigger reflow
    element.style.transition = `opacity ${duration}ms ease-in-out`;
    element.style.opacity = '1';
  }

  function fadeOutEffect(element, duration = 500) {
    element.style.transition = `opacity ${duration}ms ease-in-out`;
    element.style.opacity = '0';
    setTimeout(() => {
      element.style.display = 'none';
    }, duration);
  }

  // New helper: smoothly fade in an element without altering its content
  function fadeInElement(element, duration = 2000) {
    element.style.transition = `opacity ${duration}ms ease-in-out`;
    element.style.opacity = '1';
  }

  // ─────────────────────────────────────────────────────
  // 6) handleResponseText
  //    Instead of checking placeholder for "follow-up",
  //    we unify it under "Continue Chat."
  // ─────────────────────────────────────────────────────
  function handleResponseText(element, text) {
    const formattedText = formatResponseText(text);
    const questionInput = document.getElementById("question");
    // Is it continue-chat mode now?
    const isContinueChat = questionInput && questionInput.placeholder.includes("Continue");

    if (isContinueChat) {
      // Append to the existing content
      const separators = element.querySelectorAll('.conversation-separator');
      if (separators.length > 0) {
        const lastSeparator = separators[separators.length - 1];
        let followUpResponseDiv = element.querySelector('.follow-up-response');
        if (!followUpResponseDiv) {
          followUpResponseDiv = document.createElement('div');
          followUpResponseDiv.className = 'follow-up-response';
          if (lastSeparator.nextSibling) {
            element.insertBefore(followUpResponseDiv, lastSeparator.nextSibling);
          } else {
            element.appendChild(followUpResponseDiv);
          }
          followUpResponseDiv.style.opacity = '0';
          setTimeout(() => {
            followUpResponseDiv.style.opacity = '1';
          }, 10);
          setTimeout(() => {
            lastSeparator.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }, 100);
        }
        // Update the content
        followUpResponseDiv.innerHTML = formattedText;
      } else {
        fadeInEffect(element, formattedText);
      }
    } else {
      // For new conversation
      fadeInEffect(element, formattedText);
    }
  }

  // ─────────────────────────────────────────────────────
  // 7) Create & show "Continue Chat" button
  //    Replaces the old "showFollowUpButton" logic
  // ─────────────────────────────────────────────────────
  function showContinueChatButton() {
    // Remove any existing button
    const existingButton = document.getElementById('continue-chat-button');
    if (existingButton) {
      existingButton.remove();
    }

    // Create the new "Continue Chat" button
    const continueChatButton = document.createElement('button');
    continueChatButton.id = 'continue-chat-button';
    continueChatButton.className = 'continue-chat-button';
    continueChatButton.innerHTML = '<i class="fas fa-comment-dots"></i> Continue Chat';
    continueChatButton.type = 'button';

    // On click, unify the logic in handleContinueChat()
    continueChatButton.addEventListener('click', function(event) {
      event.preventDefault();
      event.stopPropagation();
      console.log("Continue Chat button clicked - setting up chat input.");
      // Hide the old response box if it exists and isn't already hidden by chat-mode
      const responseBox = document.getElementById('response');
      if (responseBox && !responseBox.classList.contains('chat-mode')) {
        responseBox.style.display = 'none';
      }
      // Ensure chat container is visible and setup input
      const chatContainer = document.getElementById('chat-container');
      if (chatContainer) {
        chatContainer.style.display = 'flex';
        chatContainer.classList.add('visible');
        chatContainer.style.opacity = '1'; // Ensure fully visible
        setupChatInput(); // Set up the actual chat input listeners
        // Remove this button after clicking
        continueChatButton.remove(); 
      } else {
         console.error("Chat container not found when clicking Continue Chat.");
      }
    });

    // Insert it
    const responseBox = document.getElementById('response');
    const container = document.querySelector('.container');
    if (responseBox && responseBox.parentNode) {
      responseBox.parentNode.insertBefore(continueChatButton, responseBox.nextSibling);
    } else if (container) {
      container.appendChild(continueChatButton);
    } else {
      document.body.appendChild(continueChatButton);
    }

    // Fade in
    setTimeout(() => {
      continueChatButton.classList.add('visible');
    }, 100);
  }

  // ─────────────────────────────────────────────────────
  // 8) handleContinueChat()
  //    Replaces old handleFollowUp, merges logic
  // ─────────────────────────────────────────────────────
  function handleContinueChat() {
    // Reset newSearchClicked
    newSearchClicked = false;

    const isLoggedIn = (
      document.querySelector('.slide-menu-content .profile-link') !== null ||
      document.querySelector('.menu-item.profile-link') !== null ||
      document.cookie.includes('session=')
    );
    console.log("User login status:", isLoggedIn);

    if (isLoggedIn) {
      const responseDiv = document.getElementById("response");
      // Check if a separator exists
      const existingSeparators = responseDiv.querySelectorAll('.conversation-separator');
      if (
        existingSeparators.length === 0 ||
        (existingSeparators[existingSeparators.length - 1].nextElementSibling &&
          existingSeparators[existingSeparators.length - 1].nextElementSibling.classList.contains('follow-up-response'))
      ) {
        const separator = document.createElement('div');
        separator.className = 'conversation-separator';
        separator.innerHTML = '<hr><div class="separator-text">Continue Chat</div><hr>';
        responseDiv.appendChild(separator);
      }

      // Switch placeholder to "Continue the conversation..."
      const questionInput = document.getElementById("question");
      questionInput.placeholder = "Continue the conversation...";
      questionInput.focus();
      questionInput.classList.add('continue-chat-mode');

      // Update the ask button
      const searchButton = document.getElementById("askButton");
      searchButton.innerHTML = "<i class='fas fa-comment-dots'></i> Continue Chat";
      searchButton.classList.remove('new-search-mode');
      searchButton.classList.add('continue-chat-mode');

      // Remove the continue chat button
      const continueChatButton = document.getElementById('continue-chat-button');
      if (continueChatButton) {
        continueChatButton.remove();
      }

      // Show "New Search" at bottom
      createNewSearchButton();
    } else {
      // Show login prompt if not logged in
      showLoginPrompt();
    }
  }

  // ─────────────────────────────────────────────────────
  // 9) Create new search button at bottom (unchanged except references)
  // ─────────────────────────────────────────────────────
  function createNewSearchButton() {
    // Remove any existing new search button
    const existingButton = document.getElementById('new-search-button');
    if (existingButton) {
      existingButton.remove();
    }

    const newSearchButton = document.createElement('button');
    newSearchButton.id = 'new-search-button';
    newSearchButton.className = 'new-search-button';
    newSearchButton.innerHTML = '<i class="fas fa-search"></i> New Search';
    newSearchButton.type = 'button';

    newSearchButton.addEventListener('click', function(event) {
      event.preventDefault();
      event.stopPropagation();
      handleNewSearch();
    });

    const responseBox = document.getElementById('response');
    const container = document.querySelector('.container');
    if (responseBox && responseBox.parentNode) {
      responseBox.parentNode.insertBefore(newSearchButton, responseBox.nextSibling);
    } else if (container) {
      container.appendChild(newSearchButton);
    } else {
      document.body.appendChild(newSearchButton);
    }

    setTimeout(() => {
      newSearchButton.classList.add('visible');
    }, 100);
  }

  // ─────────────────────────────────────────────────────
  // 10) handleNewSearch()
  //     Unchanged except we call showContinueChatButton()
  //     instead of old showFollowUpButton() after clearing
  // ─────────────────────────────────────────────────────
  function handleNewSearch() {
    const responseDiv = document.getElementById("response");
    const separators = responseDiv.querySelectorAll('.conversation-separator');
    separators.forEach(separator => {
      if (!separator.nextElementSibling || !separator.nextElementSibling.classList.contains('follow-up-response')) {
        separator.remove();
      }
    });
    newSearchClicked = true;

    const questionInput = document.getElementById("question");
    questionInput.value = '';
    questionInput.placeholder = "Ask any question about evidence law . . .";
    questionInput.classList.remove('continue-chat-mode');
    questionInput.focus();

    const searchButton = document.getElementById("askButton");
    searchButton.innerHTML = "<i class='fas fa-search'></i> New Search";
    searchButton.classList.remove('continue-chat-mode');
    searchButton.classList.add('new-search-mode');

    // Remove the new search button
    const newSearchButton = document.getElementById('new-search-button');
    if (newSearchButton) {
      newSearchButton.remove();
    }

    // Reset conversation ID
    currentConversationId = null;

    // Show the "Continue Chat" button if there's content in the response
    if (responseDiv && responseDiv.textContent.trim() !== '') {
      showContinueChatButton();
    }
  }

  // ─────────────────────────────────────────────────────
  // 11) showLoginPrompt() for non-logged-in (unchanged)
  // ─────────────────────────────────────────────────────
  function showLoginPrompt() {
    if (document.getElementById('login-prompt')) {
      return;
    }
    const loginPrompt = document.createElement('div');
    loginPrompt.id = 'login-prompt';
    loginPrompt.className = 'login-prompt';

    loginPrompt.innerHTML = `
      <div class="login-prompt-content">
        <h3>Continue the Conversation</h3>
        <p>To ask follow-up questions and save your conversation history, please log in or create an account.</p>
        <div class="login-prompt-buttons">
          <a href="/login" class="login-button">Log In</a>
          <a href="/register" class="register-button">Register</a>
          <button class="cancel-button">Cancel</button>
        </div>
      </div>
    `;
    document.body.appendChild(loginPrompt);

    const cancelButton = loginPrompt.querySelector('.cancel-button');
    cancelButton.addEventListener('click', () => {
      loginPrompt.remove();
    });

    setTimeout(() => {
      loginPrompt.classList.add('visible');
    }, 10);
  }

  // Function to get or create the status span
  const getOrCreateStatusSpan = () => {
      const typingMessage = document.querySelector('.message.ai.typing-message');
      if (!typingMessage) return null;
      let statusSpan = typingMessage.querySelector('.search-status-text');
      if (!statusSpan) {
          statusSpan = document.createElement('span');
          statusSpan.className = 'search-status-text';
          const contentDiv = typingMessage.querySelector('.message-content');
          const indicator = contentDiv ? contentDiv.querySelector('.typing-indicator') : null;
          if (contentDiv && indicator) {
               contentDiv.insertBefore(statusSpan, indicator.nextSibling);
          } else if (contentDiv) {
               contentDiv.appendChild(statusSpan);
          } else {
              return null;
          }
      }
      return statusSpan;
  };

  // ─────────────────────────────────────────────────────
  // 13) handleSearch()
  //     Merges "follow-up" logic with new "Continue Chat" references
  // ─────────────────────────────────────────────────────
  async function handleSearch() {
    const questionInput = document.getElementById("question");
    const searchButton = document.getElementById("askButton");
    const responseDiv = document.getElementById("response");
    const fileInput = document.getElementById("search-file-input");
    const searchFilePreview = document.getElementById("search-file-preview");
    
    // Get the question
    const question = questionInput.value.trim();
    
    // Check if we have either a question or files
    if (!question && (!fileInput || fileInput.files.length === 0)) {
      responseDiv.innerHTML = "<span class='error'>Please enter a question or attach a file.</span>";
      return;
    }
  
    if (isFetching) {
      return;
    }
    isFetching = true;
    isStreaming = true;
    searchButton.disabled = true;

    // --- Start Randomized Status Message Logic --- 
    if (statusIntervalId) {
        clearInterval(statusIntervalId);
        statusIntervalId = null;
    }
    const statusUpdateInterval = 4000;

    setTimeout(() => {
        if (!isFetching) return;
        const initialStatusSpan = getOrCreateStatusSpan();
        if (initialStatusSpan) {
            const initialRandomIndex = Math.floor(Math.random() * randomStatusMessages.length);
            initialStatusSpan.textContent = randomStatusMessages[initialRandomIndex];
            initialStatusSpan.style.animation = 'none';
            void initialStatusSpan.offsetWidth;
            initialStatusSpan.style.animation = `messageFadeCycle 3.5s ease-in-out 1 forwards, travelingHighlight 1.5s linear 1`;
        }
    }, 80);

    statusIntervalId = setInterval(() => {
        if (!isFetching) { 
            clearInterval(statusIntervalId);
            statusIntervalId = null;
            removeStatusSpanText();
            return;
        }
        const statusSpan = getOrCreateStatusSpan(); 
        if (statusSpan) {
            const randomIndex = Math.floor(Math.random() * randomStatusMessages.length);
            statusSpan.textContent = randomStatusMessages[randomIndex];
            const animationDuration = (statusUpdateInterval / 1000) - 0.5;
            statusSpan.style.animation = 'none';
            void statusSpan.offsetWidth; 
            statusSpan.style.animation = `messageFadeCycle ${animationDuration}s ease-in-out 1 forwards, travelingHighlight ${animationDuration}s linear 1`;
        }
    }, statusUpdateInterval);
    // --- End Randomized Status Message Logic --- 

    const isContinueChat = questionInput.placeholder.includes("Continue");
    if (isContinueChat) {
      searchButton.innerHTML = "<i class='fas fa-spinner fa-spin'></i> Sending...";
    } else {
      searchButton.innerHTML = "<i class='fas fa-spinner fa-spin'></i> Searching...";
    }
  
    responseDiv.style.pointerEvents = "auto";
    responseDiv.style.overflow = "auto";
  
    const existingContinueChatButton = document.getElementById('continue-chat-button');
    if (existingContinueChatButton) {
      existingContinueChatButton.remove();
    }
    const existingNewSearchButton = document.getElementById('new-search-button');
    if (existingNewSearchButton) {
      existingNewSearchButton.remove();
    }
  
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 90000); // 90s for high-reasoning Argon
  
    try {
      if (!currentConversationId) {
        currentConversationId = Math.random().toString(36).substring(2, 15);
      }

      const csrfToken = getCsrfToken();
      if (!csrfToken) {
        console.error("CSRF token not found!");
        responseDiv.innerHTML = "<span class='error'>Could not verify your request. Please refresh the page.</span>";
        isFetching = false;
        searchButton.disabled = false;
        searchButton.innerHTML = isContinueChat ? "<i class='fas fa-comment-dots'></i> Continue Chat" : "<i class='fas fa-search'></i> Search";
        return;
      }

      const stagedSearchFiles = (fileInput && fileInput.files.length > 0) ? Array.from(fileInput.files) : [];
      const attachedNames = stagedSearchFiles.map(f => f.name).join(', ');
      const displayQuestion = attachedNames
        ? (question ? `${question}\n[📎 Attached: ${attachedNames}]` : `[📎 Attached: ${attachedNames}]`)
        : question;

      const shouldTransition = !isContinueChat && !inChatMode;
      if (shouldTransition) {
        transitionToChatMode(displayQuestion);
      } else {
        addChatMessage('user', displayQuestion);
        addEmptyAIMessage();
      }

      let payload;
      if (stagedSearchFiles.length > 0) {
        const formData = new FormData();
        formData.append('question', question || `[Attached: ${attachedNames}]`);
        stagedSearchFiles.forEach(file => {
          formData.append('files[]', file);
        });
        if (currentConversationId) {
          formData.append('conversation_id', currentConversationId);
        }
        if (fileInput) {
          fileInput.value = '';
          if (searchFilePreview) {
            searchFilePreview.style.display = 'none';
            searchFilePreview.innerHTML = '';
          }
        }
        const uploadResp = await fetch('/upload', {
          method: 'POST',
          headers: { 'X-CSRFToken': csrfToken },
          body: formData
        });
        let uploadResult = {};
        try {
          uploadResult = await uploadResp.json();
        } catch (_) {}
        if (!uploadResp.ok || !uploadResult.success) {
          throw new Error(uploadResult.message || `File upload failed (${uploadResp.status})`);
        }
        payload = {
          question: question || `Please review my attached file(s): ${attachedNames}`,
          fileIds: uploadResult.files.map(f => f.id),
          conversation_id: currentConversationId,
          proMode: true,
          is_follow_up: isContinueChat
        };
      } else {
        payload = {
          question: question,
          conversation_id: currentConversationId,
          proMode: true,
          is_follow_up: isContinueChat
        };
      }

      const response = await fetch('/ask', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRFToken': csrfToken
        },
        body: JSON.stringify(payload),
        signal: controller.signal
      });
      clearTimeout(timeoutId);

      let aiMessageElement = document.querySelector('.message.ai.typing-message:last-of-type') ||
                             document.querySelector('.message.ai:last-of-type');
      if (!aiMessageElement) {
        aiMessageElement = addEmptyAIMessage();
      }

      if (!response.ok) {
        if (aiMessageElement) aiMessageElement.remove();
        throw new Error(`Server responded with ${response.status}: ${response.statusText}`);
      }

      if (response.headers.get('Content-Type')?.includes('text/event-stream')) {
        await processStream(response, aiMessageElement);
      } else {
        if (aiMessageElement) aiMessageElement.remove();
        const result = await response.json();
        addChatMessage('ai', result.answer || "No response content.");
      }
    } catch (err) {
      console.error("Error during handleSearch:", err);
      clearTimeout(timeoutId);
      
      const errorText = err.name === 'AbortError' ? "Request timed out. Please try again." : `Error: ${err.message}`;
      if (inChatMode) {
          let errorTargetElement = document.querySelector('.message.ai:last-of-type');
          if (errorTargetElement && document.body.contains(errorTargetElement)) {
              const contentDiv = errorTargetElement.querySelector('.message-content');
              if (contentDiv) {
                  contentDiv.innerHTML = `<span class='error'>${errorText}</span>`;
                  errorTargetElement.classList.remove('typing-message');
              } else {
                  addErrorMessage(errorText);
              }
          } else {
              addErrorMessage(errorText);
          }
      } else if (responseDiv) {
          responseDiv.innerHTML = `<span class='error'>${errorText}</span>`;
      }
      removeTypingIndicator();
    } finally {
       console.log("[handleSearch Finally] Running cleanup.");
       isFetching = false;
       isStreaming = false;
       if (statusIntervalId) {
           clearInterval(statusIntervalId);
           statusIntervalId = null;
       }

       const searchButton = document.getElementById("askButton");
       const questionInput = document.getElementById("question");
       if (searchButton && questionInput) {
         const isContinueChat = questionInput.placeholder.includes("Continue");
         searchButton.disabled = false;
         searchButton.innerHTML = isContinueChat ? "<i class='fas fa-comment-dots'></i> Continue Chat" : "<i class='fas fa-search'></i> Search";
       }

       statusMessageTimeouts.forEach(clearTimeout);
       statusMessageTimeouts = [];
       removeStatusSpanText();

       const responseDiv = document.getElementById("response");
       if (!inChatMode && responseDiv && responseDiv.textContent.trim() !== '') {
          showContinueChatButton();
       }
    }
  }

  // ─────────────────────────────────────────────────────
  // 16) Check URL parameters on page load (unchanged)
  // ─────────────────────────────────────────────────────
  function checkUrlParameters() {
    const urlParams = new URLSearchParams(window.location.search);
    const followUpQuestion = urlParams.get('follow_up');
    const conversationId = urlParams.get('conversation_id');

    if (followUpQuestion) {
      const questionInput = document.getElementById("question");
      questionInput.value = followUpQuestion;
      adjustTextareaHeight(questionInput);
      if (conversationId) {
        currentConversationId = conversationId;
      }
      setTimeout(() => {
        handleSearch();
      }, 500);
    }
  }

  // ─────────────────────────────────────────────────────
  // 17) Setup search input (unchanged except references)
  // ─────────────────────────────────────────────────────
  function setupSearchInput() {
    console.log("Setting up search input");

    const searchInput = document.getElementById("question");
    const askButton = document.getElementById("askButton");

    if (!searchInput) {
      console.error("Search input element not found");
      return;
    }
    if (!askButton) {
      console.error("Ask button element not found");
      return;
    }

    const oldSearchInput = searchInput;
    const newSearchInput = oldSearchInput.cloneNode(true);
    oldSearchInput.parentNode.replaceChild(newSearchInput, oldSearchInput);

    const oldAskButton = askButton;
    const newAskButton = oldAskButton.cloneNode(true);
    oldAskButton.parentNode.replaceChild(newAskButton, oldAskButton);

    newSearchInput.oninput = function() {
      adjustTextareaHeight(this);
    };
    
    adjustTextareaHeight(newSearchInput);

    newAskButton.onclick = function(event) {
      event.preventDefault();
      event.stopPropagation();
      handleSearch();
      return false;
    };
    newSearchInput.onkeydown = function(event) {
      if (event.key === 'Enter' && !event.shiftKey) {
        event.preventDefault();
        handleSearch();
        return false;
      }
    };
    newSearchInput.focus();
  }

  // ─────────────────────────────────────────────────────
  // Initialize everything
  // ─────────────────────────────────────────────────────
  try {
    setupSearchInput();
  } catch (e) {
    console.warn('setupSearchInput failed or not applicable on this page:', e);
  }

  (function(){
    const responseEl = document.getElementById("response");
    if (responseEl && responseEl.addEventListener) {
      responseEl.addEventListener("scroll", function() {
        const responseBox = this;
        const isAtBottom = responseBox.scrollHeight - responseBox.scrollTop <= responseBox.clientHeight + 50;
        if (isAtBottom) {
          responseBox.classList.add('at-bottom');
        } else {
          responseBox.classList.remove('at-bottom');
        }
      });
    }
  })();

  checkUrlParameters();
  checkFollowUpData();

  // ─────────────────────────────────────────────────────
  // 18) New chat interface functions
  // ─────────────────────────────────────────────────────

  // transitionToChatMode — synchronous DOM creation + smooth 250ms fade
  function transitionToChatMode(question) {
    console.log("Transitioning to chat mode");
    inChatMode = true;

    const container = document.querySelector('.container');
    const responseBox = document.getElementById('response');
    const chatContainer = document.getElementById('chat-container');
    const searchBox = document.querySelector('.search-box');
    const searchInterface = document.querySelector('.search-interface');
    const logo = document.querySelector('.logo');
    const tagline = document.querySelector('.tagline');
    
    const fadeDuration = 250;

    if (container) container.classList.add('chat-mode');
    if (responseBox) responseBox.classList.add('chat-mode');
    
    if (searchBox) {
      searchBox.style.display = 'none';
    }
    
    if (searchInterface) {
      searchInterface.classList.remove('fade-out');
      searchInterface.style.display = 'flex';
      searchInterface.style.opacity = '1';
    }
    
    startScrollCheck();

    if (chatContainer) {
      chatContainer.style.opacity = '0';
      chatContainer.style.display = 'flex';
      chatContainer.classList.add('visible');
      chatContainer.style.transition = `opacity ${fadeDuration}ms ease-out`;
    }

    if (logo) {
      logo.style.transition = `opacity ${fadeDuration}ms ease-out`;
      logo.style.opacity = '1';
    }
    if (tagline) {
      tagline.style.transition = `opacity ${fadeDuration}ms ease-out`;
      tagline.style.opacity = '1';
    }

    // Synchronously populate chat messages so aiMessageElement exists immediately
    const chatMessages = document.getElementById('chat-messages');
    if (chatMessages) {
      chatMessages.innerHTML = '';
      addChatMessage('user', question);
      const aiMessageElement = addEmptyAIMessage();
      chatMessages.scrollTop = 0;
      setupChatInput();
      adjustChatContainerSize();
      requestAnimationFrame(() => {
        if (chatContainer) chatContainer.style.opacity = '1';
        adjustChatContainerSize();
      });
      return aiMessageElement;
    }
    return null;
  }

  // addEmptyAIMessage
  function addEmptyAIMessage() {
    const chatMessages = document.getElementById('chat-messages');
    const messageDiv = document.createElement('div');
    // Add a unique ID for targeting
    const messageId = `ai-message-${Date.now()}-${Math.random().toString(36).substring(2, 7)}`;
    messageDiv.id = messageId;
    // Add typing-message class to identify this specific message
    messageDiv.className = 'message ai typing-message';

    const contentDiv = document.createElement('div');
    contentDiv.className = 'message-content'; // This is now a flex container via CSS

    // Add typing indicator dots FIRST
    const typingIndicator = document.createElement('div');
    typingIndicator.className = 'typing-indicator';
    typingIndicator.innerHTML = '<div class="typing-dot"></div><div class="typing-dot"></div><div class="typing-dot"></div>';
    contentDiv.appendChild(typingIndicator); // Add dots

    // Status text span will be added dynamically later when the first message appears

    messageDiv.appendChild(contentDiv);
    chatMessages.appendChild(messageDiv);
    
    // Return the created message element
    return messageDiv; 
  }

  // completeTransitionToChatMode
  function completeTransitionToChatMode(question, response) {
    console.log("Completing transition to chat mode");
    inChatMode = true;

    const container = document.querySelector('.container');
    const responseBox = document.getElementById('response');
    const chatContainer = document.getElementById('chat-container');
    const chatMessages = document.getElementById('chat-messages');
    const chatInputContainer = document.querySelector('.chat-input-container');
    const searchBox = document.querySelector('.search-box'); // Get the search box
    const searchInterface = document.querySelector('.search-interface'); // Get the search interface
    const proModeToggleContainer = document.querySelector('.pro-mode-toggle-container'); // Get the PRO toggle container
    const logo = document.querySelector('.logo'); // Get the logo
    const tagline = document.querySelector('.tagline'); // Get the tagline

    if (!container || !responseBox || !chatContainer || !chatMessages || !chatInputContainer) {
      console.error("One or more required elements not found");
      return;
    }

    // Set consistent fade duration for all elements
    const fadeDuration = 2000;
    
    // First, ensure all elements are hidden before transitioning
    if (proModeToggleContainer) {
      proModeToggleContainer.style.opacity = '0';
    }
    
    // Ensure logo and tagline are initially hidden
    if (logo) logo.style.opacity = '0';
    if (tagline) tagline.style.opacity = '0';

    // Start checking for more content
    startScrollCheck();

    container.classList.add('chat-mode');
    responseBox.classList.add('chat-mode');
    
    // Hide the search box in chat mode, but keep the search interface visible
    if (searchBox) {
      searchBox.style.display = 'none';
    }
    
    // Ensure the search interface remains visible
    if (searchInterface) {
      searchInterface.classList.remove('fade-out');
      // Ensure the search interface is visible (use flex to match CSS)
      searchInterface.style.display = 'flex';
      searchInterface.style.opacity = '1';
    }

    // Set up all elements for synchronized fade-in
    chatContainer.style.opacity = '0';
    chatContainer.style.display = 'flex';
    chatContainer.classList.add('visible');
    
    // Set consistent transition for all elements
    chatContainer.style.transition = `opacity ${fadeDuration}ms ease-in`;
    
    // Set transitions for logo and tagline to match
    if (logo) {
      logo.style.transition = `opacity ${fadeDuration}ms ease-in`;
    }
    
    if (tagline) {
      tagline.style.transition = `opacity ${fadeDuration}ms ease-in`;
    }

    chatMessages.innerHTML = '';
    addChatMessage('user', question);
    addChatMessage('ai', response);

    setupChatInput();
    // Set scroll to the top of the chat history when first transitioning to chat mode
    chatMessages.scrollTop = 0;
    
    // Fade in all elements together with a slight delay to ensure DOM updates
    setTimeout(() => {
      // Fade in the chat container
      chatContainer.style.opacity = '1';
      
      // Fade in the logo and tagline
      if (logo) logo.style.opacity = '1';
      if (tagline) tagline.style.opacity = '1';
      
      // Fade in the Pro Toggle Container
      if (proModeToggleContainer) {
        proModeToggleContainer.style.transition = `opacity ${fadeDuration}ms ease-in`;
        proModeToggleContainer.style.opacity = '1';
      }
      
      // Fade in the pro-mode-notice if PRO mode is enabled
      if (proModeEnabled) {
        const proModeNotice = document.querySelector('.pro-mode-notice');
        if (proModeNotice) {
          proModeNotice.classList.add('visible');
          proModeNotice.style.transform = 'none'; // Ensure no transform is applied
          proModeNotice.style.transition = `opacity ${fadeDuration}ms ease-in`;
          proModeNotice.style.opacity = '1';
        }
      }
    }, 100); // Slightly longer delay to ensure all DOM updates are complete

    console.log("Chat mode transition complete");
  }

  // addChatMessage
  function addChatMessage(type, content) {
    const chatMessages = document.getElementById('chat-messages');
    
    // Store current scroll position and check if user was at the bottom
    const scrollPosition = chatMessages.scrollTop;
    const isAtBottom = Math.abs(chatMessages.scrollHeight - chatMessages.scrollTop - chatMessages.clientHeight) < 10;
    
    const messageDiv = document.createElement('div');
    messageDiv.className = `message ${type}`;

    const contentDiv = document.createElement('div');
    contentDiv.className = 'message-content';

    if (type === 'ai') {
      contentDiv.innerHTML = formatResponseText(content);
    } else {
      contentDiv.textContent = content;
    }

    messageDiv.appendChild(contentDiv);
    
    // Add message actions container with copy and retry icons
    console.log(`[addChatMessage] Adding actions for type: ${type}`); // <<< LOGGING
    const messageActions = document.createElement('div');
    messageActions.className = 'message-actions';
    
    // Add copy button for both user and AI messages
    const copyButton = document.createElement('button');
    copyButton.className = 'message-action-btn copy-btn';
    copyButton.innerHTML = '<i class="fas fa-copy"></i>';
    copyButton.setAttribute('aria-label', 'Copy message');
    copyButton.setAttribute('title', 'Copy message');
    copyButton.addEventListener('click', () => {
      // Copy message content to clipboard
      const textToCopy = type === 'ai' 
        ? contentDiv.innerText || contentDiv.textContent 
        : content;
      navigator.clipboard.writeText(textToCopy)
        .then(() => {
          // Show temporary success indicator
          copyButton.innerHTML = '<i class="fas fa-check"></i>';
          setTimeout(() => {
            copyButton.innerHTML = '<i class="fas fa-copy"></i>';
          }, 2000);
        })
        .catch(err => {
          console.error('Failed to copy text: ', err);
        });
    });
    
    messageActions.appendChild(copyButton);
    
    // Add retry button for both user and AI messages
    const retryButton = document.createElement('button');
    retryButton.className = 'message-action-btn retry-btn';
    retryButton.innerHTML = '<i class="fas fa-redo-alt"></i>';
    retryButton.setAttribute('aria-label', 'Retry message');
    retryButton.setAttribute('title', 'Retry message');
    
    // For AI messages, find the corresponding user message
    if (type === 'ai') {
      // Find the previous user message
      const userMessages = chatMessages.querySelectorAll('.message.user');
      if (userMessages.length > 0) {
        const lastUserMessage = userMessages[userMessages.length - 1];
        
        retryButton.addEventListener('click', () => {
          // Get the current content from the user message (which may have been edited)
          const userContent = lastUserMessage.querySelector('.message-content').textContent;
          
          // Set the chat input value to the user message content
          const chatInput = document.getElementById('chat-input');
          if (chatInput) {
            chatInput.value = userContent;
            adjustTextareaHeight(chatInput);
            
            // Check if this is the first AI message (first search)
            const aiMessages = chatMessages.querySelectorAll('.message.ai');
            const isFirstSearch = aiMessages.length === 1;
            
            // If this is the first search, we need to handle it differently
            if (isFirstSearch && !inChatMode) {
              // This is the first search, so we need to re-run the initial search
              const questionInput = document.getElementById('question');
              if (questionInput) {
                questionInput.value = userContent;
                const askButton = document.getElementById('askButton');
                if (askButton) {
                  // Automatically click the button to start the search
                  askButton.click();
                }
              }
            } else {
              // This is a continue chat, so just send the message
              const sendButton = document.getElementById('chat-send-button');
              if (sendButton) {
                // Automatically click the button to continue the chat
                sendButton.click();
              }
            }
          }
        });
      }
    } else {
      // For user messages, use the current content
      retryButton.addEventListener('click', () => {
        // Get the current content from the message (which may have been edited)
        const currentContent = contentDiv.textContent;
        
        // Set the chat input value to this message's content
        const chatInput = document.getElementById('chat-input');
        if (chatInput) {
          chatInput.value = currentContent;
          adjustTextareaHeight(chatInput);
          
          // Automatically click the send button to continue the chat
          const sendButton = document.getElementById('chat-send-button');
          if (sendButton) {
            sendButton.click();
          }
        }
      });
    }
    
    messageActions.appendChild(retryButton);
    
    // Add edit button for user messages only
    if (type === 'user') {
      const editButton = document.createElement('button');
      editButton.className = 'message-action-btn edit-btn';
      editButton.innerHTML = '<i class="fas fa-pencil-alt"></i>';
      editButton.setAttribute('aria-label', 'Edit message');
      editButton.setAttribute('title', 'Edit message');
      
      editButton.addEventListener('click', () => {
        // Make the content editable
        contentDiv.setAttribute('contenteditable', 'true');
        contentDiv.focus();
        
        // Add a save button
        const saveButton = document.createElement('button');
        saveButton.className = 'message-action-btn save-btn';
        saveButton.innerHTML = '<i class="fas fa-check"></i>';
        saveButton.setAttribute('aria-label', 'Save edits');
        saveButton.setAttribute('title', 'Save edits');
        
        saveButton.addEventListener('click', () => {
          // Save the edited content
          const newContent = contentDiv.textContent.trim();
          contentDiv.textContent = newContent;
          contentDiv.removeAttribute('contenteditable');
          
          // Remove the save button
          saveButton.remove();
          
          // Show the edit button again
          editButton.style.display = 'inline-flex';
        });
        
        // Hide the edit button while editing
        editButton.style.display = 'none';
        
        // Add the save button
        messageActions.insertBefore(saveButton, retryButton);
      });
      
      messageActions.appendChild(editButton);
    }
    
    messageDiv.appendChild(messageActions);
    chatMessages.appendChild(messageDiv);
    
    // Only scroll to bottom if the user was already at the bottom before the update
    if (isAtBottom) {
      chatMessages.scrollTop = chatMessages.scrollHeight;
    }
    
    // Check if there's more content to show the fade effect
    checkForMoreContent();
  }

  // updateLastAIMessage
  function updateLastAIMessage(content) {
    console.log("Updating last AI message with content length:", content.length);
    const chatMessages = document.getElementById('chat-messages');
    if (!chatMessages) {
      console.error("Chat messages container not found");
      return;
    }
    
    // Store current scroll position and check if user was at the bottom
    // Do this first before any DOM modifications
    const scrollPosition = chatMessages.scrollTop;
    const isAtBottom = Math.abs(chatMessages.scrollHeight - chatMessages.scrollTop - chatMessages.clientHeight) < 10;
    
    // First, check if there's a typing message we can replace
    let typingMessage = chatMessages.querySelector('.message.ai.typing-message');
    
    if (typingMessage) {
      console.log("Found typing message to update");
      const contentDiv = typingMessage.querySelector('.message-content');
      if (contentDiv) {
        // Remove the typing indicator if it exists
        const typingIndicator = contentDiv.querySelector('.typing-indicator');
        if (typingIndicator) {
          typingIndicator.remove();
        }
        
        // Update with the formatted content
        const formattedContent = formatResponseText(content);
        contentDiv.innerHTML = formattedContent;
        
        // Remove the typing-message class
        typingMessage.classList.remove('typing-message');
        
        console.log("Updated typing message with content");
      }
    } else {
      // If no typing message, look for the last AI message
      let lastAIMessage = chatMessages.querySelector('.message.ai:last-child');
      
      if (!lastAIMessage || lastAIMessage.classList.contains('user')) {
        console.log("No suitable AI message found, adding new one");
        addChatMessage('ai', content);
        return;
      }
      
      const contentDiv = lastAIMessage.querySelector('.message-content');
      if (!contentDiv) {
        console.error("Content div not found in last AI message");
        return;
      }
      
      const formattedContent = formatResponseText(content);
      contentDiv.innerHTML = formattedContent;
      console.log("Updated existing AI message content");
    }
    
    // Ensure the message has action buttons (only add if they don't exist)
    const currentMessage = typingMessage || chatMessages.querySelector('.message.ai:last-child');
    if (currentMessage && !currentMessage.querySelector('.message-actions')) {
      console.log("[updateLastAIMessage] Adding action buttons to AI message (because they were missing)"); // <<< LOGGING
      const messageActions = document.createElement('div');
      messageActions.className = 'message-actions';
      
      // Add copy button
      const copyButton = document.createElement('button');
      copyButton.className = 'message-action-btn copy-btn';
      copyButton.innerHTML = '<i class="fas fa-copy"></i>';
      copyButton.setAttribute('aria-label', 'Copy message');
      copyButton.setAttribute('title', 'Copy message');
      
      const contentDiv = currentMessage.querySelector('.message-content');
      copyButton.addEventListener('click', () => {
        const textToCopy = contentDiv.innerText || contentDiv.textContent;
        navigator.clipboard.writeText(textToCopy)
          .then(() => {
            copyButton.innerHTML = '<i class="fas fa-check"></i>';
            setTimeout(() => {
              copyButton.innerHTML = '<i class="fas fa-copy"></i>';
            }, 2000);
          })
          .catch(err => {
            console.error('Failed to copy text: ', err);
          });
      });
      
      messageActions.appendChild(copyButton);
      
      // Add retry button
      const retryButton = document.createElement('button');
      retryButton.className = 'message-action-btn retry-btn';
      retryButton.innerHTML = '<i class="fas fa-redo-alt"></i>';
      retryButton.setAttribute('aria-label', 'Retry message');
      retryButton.setAttribute('title', 'Retry message');
      
      // Find the previous user message
      const userMessages = chatMessages.querySelectorAll('.message.user');
      if (userMessages.length > 0) {
        const lastUserMessage = userMessages[userMessages.length - 1];
        const userContent = lastUserMessage.querySelector('.message-content').textContent;
        
        retryButton.addEventListener('click', () => {
          const chatInput = document.getElementById('chat-input');
          if (chatInput) {
            chatInput.value = userContent;
            adjustTextareaHeight(chatInput);
            
            // Automatically send the message to re-run the chat
            const sendButton = document.getElementById('chat-send-button');
            if (sendButton) {
              sendButton.click();
            }
          }
        });
      }
      
      messageActions.appendChild(retryButton);
      currentMessage.appendChild(messageActions);
    }
    
    // Only scroll to bottom if the user was already at the bottom before the update
    if (isAtBottom) {
      chatMessages.scrollTop = chatMessages.scrollHeight;
    } else {
      // Maintain scroll position for users who scrolled up
      requestAnimationFrame(() => {
        chatMessages.scrollTop = scrollPosition;
      });
    }
    
    // Check if there's more content to show the fade effect
    checkForMoreContent();
  }

  // addTypingIndicator
  function addTypingIndicator() {
    console.log("Adding typing indicator");
    if (document.querySelector('.typing-indicator')) {
      console.log("Typing indicator already exists, not adding another one");
      return;
    }
    
    const chatMessages = document.getElementById('chat-messages');
    if (!chatMessages) {
      console.error("Could not find chat-messages element to add typing indicator");
      return;
    }
    
    // Store current scroll position and check if user was at the bottom
    const scrollPosition = chatMessages.scrollTop;
    const isAtBottom = Math.abs(chatMessages.scrollHeight - chatMessages.scrollTop - chatMessages.clientHeight) < 10;
    
    const typingMessage = document.createElement('div');
    typingMessage.className = 'message ai typing-message';
    
    const messageContent = document.createElement('div');
    messageContent.className = 'message-content';
    
    const typingIndicator = document.createElement('div');
    typingIndicator.className = 'typing-indicator';
    
    for (let i = 0; i < 3; i++) {
        const dot = document.createElement('span');
        dot.className = 'typing-dot';
        typingIndicator.appendChild(dot);
    }
    
    messageContent.appendChild(typingIndicator);
    typingMessage.appendChild(messageContent);
    
    chatMessages.appendChild(typingMessage);
    
    // Only scroll to bottom if the user was already at the bottom before the update
    if (isAtBottom) {
      chatMessages.scrollTop = chatMessages.scrollHeight;
    }
    
    console.log("Typing indicator added");
  }

  function removeTypingIndicator() {
    console.log("Removing typing indicator");
    // Instead of removing the entire message, we'll just remove the typing indicator
    // so we can replace it with the actual content
    const typingIndicator = document.querySelector('.typing-indicator');
    if (typingIndicator) {
      const messageContent = typingIndicator.closest('.message-content');
      if (messageContent) {
        // Just remove the typing indicator, not the entire message
        typingIndicator.remove();
        console.log("Typing indicator removed, keeping the message container");
      } else {
        console.log("Could not find message-content containing typing indicator");
      }
    } else {
      console.log("No typing indicator found to remove");
    }
  }

  // addErrorMessage
  function addErrorMessage(errorText) {
    const chatMessages = document.getElementById('chat-messages');
    if (!chatMessages) {
      console.error("Could not find chat-messages element to add error message");
      return;
    }
    
    // Store current scroll position and check if user was at the bottom
    const scrollPosition = chatMessages.scrollTop;
    const isAtBottom = Math.abs(chatMessages.scrollHeight - chatMessages.scrollTop - chatMessages.clientHeight) < 10;
    
    const errorDiv = document.createElement('div');
    errorDiv.className = 'message ai error';

    const contentDiv = document.createElement('div');
    contentDiv.className = 'message-content';
    contentDiv.innerHTML = `<span class="error">${errorText}</span>`;

    errorDiv.appendChild(contentDiv);
    chatMessages.appendChild(errorDiv);

    // Only scroll to bottom if the user was already at the bottom before the update
    if (isAtBottom) {
      chatMessages.scrollTop = chatMessages.scrollHeight;
    }
  }

  // setupChatInput
  function setupChatInput() {
    console.log("Setting up chat input");
    const chatInput = document.getElementById('chat-input');
    const chatSendButton = document.getElementById('chat-send-button');
    const newChatButton = document.getElementById('new-chat-button');
    const chatInputContainer = document.querySelector('.chat-input-container');
    const chatFileInput = document.getElementById('chat-file-input');
    const chatFilePreview = document.getElementById('chat-file-preview');

    if (!chatInput || !chatSendButton || !newChatButton || !chatInputContainer) {
      console.error("Chat input or one or more buttons/containers not found");
      return;
    }

    // Reset file input and preview
    if (chatFileInput) {
      chatFileInput.value = '';
    }
    if (chatFilePreview) {
      chatFilePreview.style.display = 'none';
      chatFilePreview.innerHTML = '';
    }

    chatInput.onkeydown = null;
    chatInput.oninput = null;
    chatSendButton.onclick = null;
    newChatButton.onclick = null;

    chatInputContainer.style.opacity = '1';
    chatInputContainer.style.pointerEvents = 'auto';
    chatInputContainer.style.transform = 'none';
    chatInputContainer.style.zIndex = '10';

    // Unify text to "Continue Chat"
    chatSendButton.innerHTML = "<i class='fas fa-comment-dots'></i> Continue Chat";

    chatInput.addEventListener("input", function() {
      adjustTextareaHeight(this);
    });
    chatInput.addEventListener("keydown", function(event) {
      console.log("Chat input keydown event fired, key =", event.key);
      if (event.key === 'Enter' && !event.shiftKey) {
        event.preventDefault();
        sendChatMessage(event);
      }
    });
    chatSendButton.addEventListener("click", function(event) {
      console.log("Chat send button clicked");
      sendChatMessage(event);
    });
    newChatButton.addEventListener("click", function(event) {
      console.log("New chat button clicked");
      startNewChat();
    });

    adjustTextareaHeight(chatInput);
    chatInput.focus();
    chatInputContainer.scrollIntoView({ behavior: 'smooth', block: 'end' });
    console.log("Chat input setup complete");
  }

  // sendChatMessage
  function sendChatMessage(event) {
    console.log("Sending chat message");

    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    const chatInput = document.getElementById('chat-input');
    const chatSendButton = document.getElementById('chat-send-button');
    const chatFileInput = document.getElementById('chat-file-input');
    const chatFilePreview = document.getElementById('chat-file-preview');

    if (!chatInput) {
      console.error("Chat input not found");
      return;
    }
    const question = chatInput.value.trim();
    
    // Check if we have either a question or files
    if (!question && (!chatFileInput || chatFileInput.files.length === 0)) {
      console.log("Empty question and no files, not sending");
      return;
    }

    if (isFetching) {
      console.log("Already fetching, not sending another request");
      return;
    }

    console.log("Processing chat message:", question);
    isFetching = true;
    isStreaming = true; // Set streaming flag to true

    // --- Start Randomized Status Message Logic (Chat) --- 
    if (statusIntervalId) {
        clearInterval(statusIntervalId);
        statusIntervalId = null;
    }
    const statusUpdateIntervalChat = 4000; // Update every 4 seconds

    // Display initial message quickly
    setTimeout(() => {
        if (!isFetching) return; 
        const initialStatusSpanChat = getOrCreateStatusSpan();
        if (initialStatusSpanChat) {
            const initialRandomIndexChat = Math.floor(Math.random() * randomStatusMessages.length);
            initialStatusSpanChat.textContent = randomStatusMessages[initialRandomIndexChat];
            initialStatusSpanChat.style.animation = 'none';
            void initialStatusSpanChat.offsetWidth; // Trigger reflow
            initialStatusSpanChat.style.animation = `messageFadeCycle 0.5s ease-in-out 1 forwards, travelingHighlight 1.5s linear 1`;
        }
    }, 100); // Show first message after 100ms

    // Start interval for subsequent messages
    statusIntervalId = setInterval(() => {
        if (!isFetching) { 
            clearInterval(statusIntervalId);
            statusIntervalId = null;
            removeStatusSpanText(); // Use helper
            return;
        }
        const statusSpan = getOrCreateStatusSpan(); 
        if (statusSpan) {
            const randomIndex = Math.floor(Math.random() * randomStatusMessages.length);
            statusSpan.textContent = randomStatusMessages[randomIndex];
            const animationDurationChat = (statusUpdateIntervalChat / 1000) - 0.5; // ~3.5s
            statusSpan.style.animation = 'none';
            void statusSpan.offsetWidth; 
            statusSpan.style.animation = `messageFadeCycle ${animationDurationChat}s ease-in-out 1 forwards, travelingHighlight ${animationDurationChat}s linear 1`;
        }
    }, statusUpdateIntervalChat);
    // --- End Randomized Status Message Logic (Chat) --- 

    if (chatSendButton) {
      chatSendButton.disabled = true;
      chatSendButton.innerHTML = "<i class='fas fa-spinner fa-spin'></i> Sending...";
    }

    const stagedChatFiles = (chatFileInput && chatFileInput.files.length > 0) ? Array.from(chatFileInput.files) : [];
    const attachedChatNames = stagedChatFiles.map(f => f.name).join(', ');
    const displayChatQuestion = attachedChatNames
      ? (question ? `${question}\n[📎 Attached: ${attachedChatNames}]` : `[📎 Attached: ${attachedChatNames}]`)
      : question;

    if (chatFileInput) {
      chatFileInput.value = '';
      if (chatFilePreview) {
        chatFilePreview.style.display = 'none';
        chatFilePreview.innerHTML = '';
      }
    }

    chatInput.value = '';
    adjustTextareaHeight(chatInput);

    addChatMessage('user', displayChatQuestion);
    const aiMessageElement = addEmptyAIMessage();
    scrollToBottom('chat-messages');

    const csrfToken = getCsrfToken();
    if (!csrfToken) {
      console.error("CSRF token was not available in sendChatMessage!");
      addErrorMessage("Could not verify your request (session error). Please refresh the page.");
      isFetching = false;
      isStreaming = false;
      if (chatSendButton) {
        chatSendButton.disabled = false;
        chatSendButton.innerHTML = "<i class='fas fa-comment-dots'></i> Continue Chat";
      }
      if (aiMessageElement) aiMessageElement.remove();
      return;
    }

    // Check if we have files to upload
    if (stagedChatFiles.length > 0) {
      const formData = new FormData();
      formData.append('question', question || `[Attached: ${attachedChatNames}]`);
      stagedChatFiles.forEach(file => {
        formData.append('files[]', file);
      });
      if (currentConversationId) {
        formData.append('conversation_id', currentConversationId);
      }
      
      fetch("/upload", {
        method: "POST",
        headers: { 'X-CSRFToken': csrfToken },
        body: formData
      })
      .then(async response => {
        let uploadResult = {};
        try {
          uploadResult = await response.json();
        } catch (_) {}
        if (!response.ok || !uploadResult.success) {
          throw new Error(uploadResult.message || `File upload failed (${response.status})`);
        }
        return uploadResult;
      })
      .then(uploadResult => {
        const questionWithFiles = {
          question: question || `Please review my attached file(s): ${attachedChatNames}`,
          fileIds: uploadResult.files.map(f => f.id),
          conversation_id: currentConversationId,
          proMode: true,
          is_follow_up: true
        };
        return fetch('/ask', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-CSRFToken': csrfToken
          },
          body: JSON.stringify(questionWithFiles)
        });
      })
      .then(async response => {
        if (!response.ok) {
          throw new Error(`Server responded with ${response.status}: ${response.statusText}`);
        }
        const targetAiEl = aiMessageElement || document.querySelector('.message.ai:last-of-type');
        if (response.headers.get('Content-Type')?.includes('text/event-stream')) {
          await processStream(response, targetAiEl);
        } else {
          if (targetAiEl) targetAiEl.remove();
          const result = await response.json();
          addChatMessage('ai', result.answer || "No response content.");
        }
      })
      .catch(err => {
        console.error("Error during chat fetch with files:", err);
        if (aiMessageElement) aiMessageElement.remove();
        addErrorMessage(err.message || "An error occurred while uploading files. Please try again.");
      })
      .finally(() => {
        isFetching = false;
        isStreaming = false;
        if (statusIntervalId) {
          clearInterval(statusIntervalId);
          statusIntervalId = null;
        }
        if (chatSendButton) {
          chatSendButton.disabled = false;
          chatSendButton.innerHTML = "<i class='fas fa-comment-dots'></i> Continue Chat";
        }
        statusMessageTimeouts.forEach(clearTimeout);
        statusMessageTimeouts = [];
        removeStatusSpanText();
        document.querySelectorAll('.message.streaming').forEach(message => {
          message.classList.remove('streaming');
        });
        if (chatInput) chatInput.focus();
      });
    } else {
      const payload = {
        question: question,
        conversation_id: currentConversationId,
        proMode: true,
        is_follow_up: true
      };
      
      fetch('/ask', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRFToken': csrfToken
        },
        body: JSON.stringify(payload)
      })
        .then(async response => {
          if (!response.ok) {
            throw new Error(`Server responded with ${response.status}: ${response.statusText}`);
          }
          const targetAiEl = aiMessageElement || document.querySelector('.message.ai:last-of-type');
          if (response.headers.get('Content-Type')?.includes('text/event-stream')) {
            await processStream(response, targetAiEl);
          } else {
            if (targetAiEl) targetAiEl.remove();
            const result = await response.json();
            addChatMessage('ai', result.answer || "No response content.");
          }
        })
        .catch(err => {
          console.error("Error during chat fetch:", err);
          if (aiMessageElement) aiMessageElement.remove();
          addErrorMessage("An error occurred. Please try again.");
        })
        .finally(() => {
          isFetching = false;
          isStreaming = false;
          if (statusIntervalId) {
            clearInterval(statusIntervalId);
            statusIntervalId = null;
          }
          if (chatSendButton) {
            chatSendButton.disabled = false;
            chatSendButton.innerHTML = "<i class='fas fa-comment-dots'></i> Continue Chat";
          }
          statusMessageTimeouts.forEach(clearTimeout);
          statusMessageTimeouts = [];
          removeStatusSpanText();
          document.querySelectorAll('.message.streaming').forEach(message => {
            message.classList.remove('streaming');
          });
          if (chatInput) chatInput.focus();
        });
    }
  }

  // startNewChat
  function startNewChat() {
    console.log("Starting new chat - redirecting to home page");
    stopScrollCheck();
    
    const chatFileInput = document.getElementById('chat-file-input');
    const chatFilePreview = document.getElementById('chat-file-preview');
    
    if (chatFileInput) {
      chatFileInput.value = '';
    }
    if (chatFilePreview) {
      chatFilePreview.style.display = 'none';
      chatFilePreview.innerHTML = '';
    }
    
    window.location.href = '/';
  }

  // Prevent wheel events from propagating outside chat container
  document.addEventListener('DOMContentLoaded', function() {
    const chatContainer = document.getElementById('chat-container');
    const chatMessages = document.getElementById('chat-messages');

    if (chatContainer && chatMessages) {
      chatMessages.addEventListener('wheel', function(event) {
        const isAtTop = chatMessages.scrollTop === 0;
        const isAtBottom =
          chatMessages.scrollHeight - chatMessages.scrollTop === chatMessages.clientHeight;

        if ((isAtTop && event.deltaY < 0) || (isAtBottom && event.deltaY > 0)) {
          return;
        }
        event.stopPropagation();
      }, { passive: false });
      
      chatMessages.addEventListener('scroll', function() {
        checkForMoreContent();
      });
    }
  });

  // Ensure proper sizing of chat container to prevent page scrolling or overlap
  function adjustChatContainerSize() {
    const chatContainer = document.getElementById('chat-container');
    const footer = document.querySelector('.footer');

    if (chatContainer && chatContainer.classList.contains('visible')) {
      const viewportHeight = window.innerHeight;
      const footerHeight = footer ? footer.offsetHeight : 32;
      const chatTop = chatContainer.getBoundingClientRect().top;
      const effectiveTop = chatTop > 0 ? chatTop : 118;

      const maxHeight = Math.max(320, viewportHeight - effectiveTop - footerHeight - 12);
      chatContainer.style.height = maxHeight + 'px';
      chatContainer.style.maxHeight = maxHeight + 'px';
    }
  }

  window.addEventListener('load', adjustChatContainerSize);
  window.addEventListener('resize', adjustChatContainerSize);

  // Also run when chat container becomes visible
  document.addEventListener('DOMContentLoaded', function() {
    const chatContainer = document.getElementById('chat-container');
    if (chatContainer) {
      const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
            if (chatContainer.classList.contains('visible')) {
              adjustChatContainerSize();
            }
          }
        });
      });
      observer.observe(chatContainer, { attributes: true });
    }
  });

  // ─────────────────────────────────────────────────────
  // Check if there's more content below the visible area
  // ─────────────────────────────────────────────────────
  function checkForMoreContent() {
    const chatMessages = document.getElementById('chat-messages');
    const fadeIndicator = document.getElementById('chat-fade-indicator');
    
    if (!chatMessages || !fadeIndicator) return;
    
    // Check if scrollable content height is greater than visible height
    // and if we're not already at the bottom
    const hasMoreContent = 
      chatMessages.scrollHeight > chatMessages.clientHeight && 
      chatMessages.scrollHeight - chatMessages.scrollTop - chatMessages.clientHeight > 20;
    
    // Add or remove the visible class based on whether there's more content
    if (hasMoreContent) {
      fadeIndicator.classList.add('visible');
    } else {
      fadeIndicator.classList.remove('visible');
    }
  }
  
  // Start checking for more content when in chat mode
  function startScrollCheck() {
    if (scrollCheckInterval) {
      clearInterval(scrollCheckInterval);
    }
    
    // Check immediately
    checkForMoreContent();
    
    // Then check periodically
    scrollCheckInterval = setInterval(checkForMoreContent, 500);
  }
  
  // Stop checking when not in chat mode
  function stopScrollCheck() {
    if (scrollCheckInterval) {
      clearInterval(scrollCheckInterval);
      scrollCheckInterval = null;
    }
    
    // Hide the fade indicator
    const fadeIndicator = document.getElementById('chat-fade-indicator');
    if (fadeIndicator) {
      fadeIndicator.classList.remove('visible');
    }
  }

  // Inject hover styles for static tooltips on disabled Upload, Chat Attach, and History elements
  const tooltipHoverStyleEl = document.createElement('style');
  tooltipHoverStyleEl.textContent = `
  #search-attach-button:hover .pro-mode-tooltip,
  #chat-attach-button:hover .pro-mode-tooltip,
  #history-link:hover .pro-mode-tooltip {
      opacity: 1;
      transform: translateX(-50%) translateY(0);
  }
  `;
  document.head.appendChild(tooltipHoverStyleEl);

  // ─────────────────────────────────────────────────────
  // History Link Functionality (Prevent if not Premium)
  // ─────────────────────────────────────────────────────
  // REMOVED - Logic moved to modals.js

  // Ensure New Search buttons always work
  const globalNewChatBtn = document.getElementById('new-chat-button');
  if (globalNewChatBtn) {
    globalNewChatBtn.addEventListener('click', function(e) {
      e.preventDefault();
      console.log("Global New Chat button clicked");
      startNewChat();
    });
  }
  const globalNewSearchBtn = document.getElementById('new-search-button');
  if (globalNewSearchBtn) {
    globalNewSearchBtn.addEventListener('click', function(e) {
      e.preventDefault();
      console.log("Global New Search button clicked");
      handleNewSearch();
    });
  }

  let csrfToken = null; // Variable to store the token
  const csrfInput = document.querySelector('#search-form input[name="csrf_token"]');
  if (csrfInput) {
    csrfToken = csrfInput.value;
    console.log("CSRF Token captured on load:", csrfToken);
  } else {
    console.error("CSRF token input not found on page load!");
    // Consider adding a user-visible error here if this is critical
  }

  // --- DOM Elements (Cached) --- //
  const container = document.querySelector('.container');

});
